// This file is auto-generated. Do not edit!

export default [
  {
    id: "0x38989BBA00BDF8181F4082995b3DEAe96163aC5D",
    version: "v1",
    name: "Flagship ETH",
    symbol: "bbETH",
    asset: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0xBEEF01735c132Ada46AA9aA4c54623cAA92A64CB",
    version: "v1",
    name: "Steakhouse USDC",
    symbol: "steakUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x2e52Efab5be3c4AacDb832386F5a670Fe1C60555",
    version: "v1",
    name: "Flagship USDC",
    symbol: "bbETH",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x186514400e52270cef3D80e1c6F8d10A75d47344",
    version: "v1",
    name: "Flagship USDC",
    symbol: "bbUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xbEEF02e5E13584ab96848af90261f0C8Ee04722a",
    version: "v1",
    name: "Steakhouse PYUSD",
    symbol: "steakPYUSD",
    asset: {
      address: "0x6c3ea9036406852006290770BEdFcAbA0e23A0e8",
      symbol: "PYUSD",
    },
  },
  {
    id: "0xbeef033b4520267C5acFcb45414117b633fCb3Dd",
    version: "v1",
    name: "Steakhouse USDM",
    symbol: "steakUSDM",
    asset: {
      address: "0x57F5E098CaD7A3D1Eed53991D4d66C45C9AF7812",
      symbol: "wUSDM",
    },
  },
  {
    id: "0xbEef047a543E45807105E51A8BBEFCc5950fcfBa",
    version: "v1",
    name: "Steakhouse USDT",
    symbol: "steakUSDT",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0x19f91632ba0367cD7B1fc8816071cB31519e5d8a",
    version: "v1",
    name: "testMorphoVault",
    symbol: "testMM",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x78Fc2c2eD1A4cDb5402365934aE5648aDAd094d0",
    version: "v1",
    name: "Re7 WETH",
    symbol: "Re7WETH",
    asset: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0x2C25f6C25770fFEC5959D34B94Bf898865e5D6b1",
    version: "v1",
    name: "Flagship USDT",
    symbol: "bbUSDT",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0xC21DB71648B18C5B9E038d88393C9b254cf8eaC8",
    version: "v1",
    name: "EUR Real Yield",
    symbol: "ERY",
    asset: {
      address: "0x3231Cb76718CDeF2155FC47b5286d82e6eDA273f",
      symbol: "EURe",
    },
  },
  {
    id: "0x2371e134e3455e0593363cBF89d3b6cf53740618",
    version: "v1",
    name: "Gauntlet WETH Prime",
    symbol: "gtWETH",
    asset: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0xdd0f28e19C1780eb6396170735D45153D261490d",
    version: "v1",
    name: "Gauntlet USDC Prime",
    symbol: "gtUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xBEEf050ecd6a16c4e7bfFbB52Ebba7846C4b8cD4",
    version: "v1",
    name: "Steakhouse ETH",
    symbol: "steakETH",
    asset: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0xbEeF06E7027EB8A1F0ab6ceF743542EA31b8492b",
    version: "v1",
    name: "Steakhouse EURe",
    symbol: "steakEURe",
    asset: {
      address: "0x3231Cb76718CDeF2155FC47b5286d82e6eDA273f",
      symbol: "EURe",
    },
  },
  {
    id: "0xbEeF087c8430C0f9dCBa39BA866Eb7c22200599B",
    version: "v1",
    name: "Steakhouse EURC",
    symbol: "steakEURC",
    asset: {
      address: "0x1aBaEA1f7C830bD89Acc67eC4af516284b1bC33c",
      symbol: "EURC",
    },
  },
  {
    id: "0xbeEf094333AEdD535c130958c204E84f681FD9FA",
    version: "v1",
    name: "Steakhouse WBTC",
    symbol: "steakWBTC",
    asset: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
  },
  {
    id: "0x53675a75A0D6E5C13DBfb0d691EA679357ca5DDa",
    version: "v1",
    name: "Gauntlet MKR Blended",
    symbol: "gtUSDCmkr",
    asset: {
      address: "0x9f8F72aA9304c8B593d555F12eF6589cC3A579A2",
      symbol: "MKR",
    },
  },
  {
    id: "0xEbFA750279dEfa89b8D99bdd145a016F6292757b",
    version: "v1",
    name: "Gauntlet MKR Blended",
    symbol: "gtUSDCmkr",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x8Be3f517a3382Ec57a730C41b739717b214b375d",
    version: "v1",
    name: "Scented DAI",
    symbol: "smellDAI",
    asset: {
      address: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
      symbol: "DAI",
    },
  },
  {
    id: "0x95EeF579155cd2C5510F312c8fA39208c3Be01a8",
    version: "v1",
    name: "Re7 USDT",
    symbol: "Re7USDT",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0x4cA0E178c94f039d7F202E09d8d1a655Ed3fb6b6",
    version: "v1",
    name: "LeadBlock USDC RWA",
    symbol: "USDC RWA",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xB8C7F2a4B3bF76CC04bd55Ebc259b33a67b3b36d",
    version: "v1",
    name: "Spark DAI Vault",
    symbol: "spDAI",
    asset: {
      address: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
      symbol: "DAI",
    },
  },
  {
    id: "0x73e65DBD630f90604062f6E02fAb9138e713edD9",
    version: "v1",
    name: "Spark DAI Vault",
    symbol: "spDAI",
    asset: {
      address: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
      symbol: "DAI",
    },
  },
  {
    id: "0x8CB3649114051cA5119141a34C200D65dc0Faa73",
    version: "v1",
    name: "Gauntlet USDT Prime",
    symbol: "gtUSDT",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0x500331c9fF24D9d11aee6B07734Aa72343EA74a5",
    version: "v1",
    name: "Gauntlet DAI Core",
    symbol: "gtDAIcore",
    asset: {
      address: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
      symbol: "DAI",
    },
  },
  {
    id: "0x4881Ef0BF6d2365D3dd6499ccd7532bcdBCE0658",
    version: "v1",
    name: "Gauntlet LRT Core",
    symbol: "gtLRTcore",
    asset: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0x125D41A6e5dbf455cD9Df8F80BCC6fd172D52Cc6",
    version: "v1",
    name: "Gauntlet USDA Core",
    symbol: "gtUSDAcore",
    asset: {
      address: "0x0000206329b97DB379d5E1Bf586BbDB969C63274",
      symbol: "USDA",
    },
  },
  {
    id: "0xBE40491F3261Fd42724F1AEb465796eb11c06ddF",
    version: "v1",
    name: "Re7 FRAX",
    symbol: "Re7FRAX",
    asset: {
      address: "0x853d955aCEf822Db058eb8505911ED77F175b99e",
      symbol: "FRAX",
    },
  },
  {
    id: "0x89D80f5e9BC88d8021b352064ae73F0eAf79EBd8",
    version: "v1",
    name: "Re7 USDA",
    symbol: "Re7USDA",
    asset: {
      address: "0x0000206329b97DB379d5E1Bf586BbDB969C63274",
      symbol: "USDA",
    },
  },
  {
    id: "0x67315dd969B8Cd3a3520C245837Bf71f54579C75",
    version: "v1",
    name: "LlamaRisk crvUSD Vault",
    symbol: "llama-crvUSD",
    asset: {
      address: "0xf939E0A03FB07F59A73314E73794Be0E57ac1b4E",
      symbol: "crvUSD",
    },
  },
  {
    id: "0x8eB67A509616cd6A7c1B3c8C21D48FF57df3d458",
    version: "v1",
    name: "Gauntlet USDC Core",
    symbol: "gtUSDCcore",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x60d715515d4411f7F43e4206dc5d4a3677f0eC78",
    version: "v1",
    name: "Re7 USDC",
    symbol: "Re7USDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x2a79E2c69ff4d3a50BF335153e4c09Fa360F3386",
    version: "v1",
    name: "Morpho USD0",
    symbol: "mUSD0",
    asset: {
      address: "0x73A15FeD60Bf67631dC6cd7Bc5B6e8da8190aCF5",
      symbol: "USD0",
    },
  },
  {
    id: "0x4F460bb11cf958606C69A963B4A17f9DaEEea8b6",
    version: "v1",
    name: "f(x) Protocol Morpho USDC",
    symbol: "fxUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xbeEF07E929F84466a591De130e4154667214F491",
    version: "v1",
    name: "Steakhouse EURCV",
    symbol: "steakEURCV",
    asset: {
      address: "0x5F7827FDeb7c20b443265Fc2F40845B715385Ff2",
      symbol: "EURCV",
    },
  },
  {
    id: "0xc080f56504e0278828A403269DB945F6c6D6E014",
    version: "v1",
    name: "Gauntlet eUSD Core",
    symbol: "gteUSDc",
    asset: {
      address: "0xA0d69E286B938e21CBf7E51D71F6A4c8918f482F",
      symbol: "eUSD",
    },
  },
  {
    id: "0xd63070114470f685b75B74D60EEc7c1113d33a3D",
    version: "v1",
    name: " Usual Boosted USDC",
    symbol: "USUALUSDC+",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x9a8bC3B04b7f3D87cfC09ba407dCED575f2d61D8",
    version: "v1",
    name: "MEV Capital wETH",
    symbol: "MCwETH",
    asset: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0x7f172587B13f85992e8d36c1D8723dFd1bDD931E",
    version: "v1",
    name: "MAHA.xyz ZAI Vault",
    symbol: "MZAI",
    asset: {
      address: "0x6900057428C99Fb373397D657Beb40D92D8aC97f",
      symbol: "USDz",
    },
  },
  {
    id: "0x8a0D114B72A5ba5ABF37283EF98708945db4423e",
    version: "v1",
    name: "ZAI Stablecoin Vault",
    symbol: "ZAI-MM-VAULT",
    asset: {
      address: "0x69000405f9DcE69BD4Cbf4f2865b79144A69BFE0",
      symbol: "USDz",
    },
  },
  {
    id: "0xdA1F00d47054A1807f6bf2403Ce48a14d894A18b",
    version: "v1",
    name: "RiskDAO DAI Core",
    symbol: "rdcDAI",
    asset: {
      address: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
      symbol: "DAI",
    },
  },
  {
    id: "0x443df5eEE3196e9b2Dd77CaBd3eA76C3dee8f9b2",
    version: "v1",
    name: "Gauntlet WBTC Core",
    symbol: "gtWBTCc",
    asset: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
  },
  {
    id: "0xbEEf0075e03A5cE0D84d4ACcF3481363E0584F5c",
    version: "v1",
    name: "Steakhouse M",
    symbol: "steakM",
    asset: {
      address: "0x437cc33344a0B27A429f795ff6B469C72698B291",
      symbol: "wM",
    },
  },
  {
    id: "0xE0C98605f279e4D7946d25B75869c69802823763",
    version: "v1",
    name: "Re7 WBTC",
    symbol: "Re7WBTC",
    asset: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
  },
  {
    id: "0x43fD147d5319B8Cf39a6e57143684Efca9CF3613",
    version: "v1",
    name: "Re7 tBTC",
    symbol: "Re7tBTC",
    asset: {
      address: "0x18084fbA666a33d37592fA2633fD49a74DD93a88",
      symbol: "tBTC",
    },
  },
  {
    id: "0xBeEf11eCb698f4B5378685C05A210bdF71093521",
    version: "v1",
    name: "Steakhouse RUSD",
    symbol: "steakRUSD",
    asset: {
      address: "0x09D4214C03D01F49544C0448DBE3A27f768F2b34",
      symbol: "rUSD",
    },
  },
  {
    id: "0x1B4cd53a1A8e5F50aB6320EF34E5fB4D3df7B6f6",
    version: "v1",
    name: "Gauntlet AUSD Core",
    symbol: "gtAUSDc",
    asset: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
  },
  {
    id: "0xeC3B2CC4C6a8fC9a13620A91622483b56E2E6fD9",
    version: "v1",
    name: "PufEthWeth Market 86 lltv",
    symbol: "pufethweth86lltv",
    asset: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0xF2eFEBE45180C8c04edFdBfF3d88e58C9D61a03E",
    version: "v1",
    name: "Apostro USDC",
    symbol: "apUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xB1A757A68D4a04a6B5A0F06d0cB4FD739048F614",
    version: "v1",
    name: "Apostro WETH",
    symbol: "apWETH",
    asset: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0x4FBB60166199d36dD2fB09005154F0938B6d717B",
    version: "v1",
    name: "Anzen Boosted USDC",
    symbol: "AnzenUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x4Ff4186188f8406917293A9e01A1ca16d3cf9E59",
    version: "v1",
    name: "SwissBorg Morpho USDC",
    symbol: "sbMorphoUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x1265a81d42d513Df40d0031f8f2e1346954d665a",
    version: "v1",
    name: "MEV Capital Elixir USDC",
    symbol: "MC.eUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x8E3C0A68F8065Dc666065f16cf902596A60d540e",
    version: "v1",
    name: "MEV Capital WBTC",
    symbol: "MCwBTC",
    asset: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
  },
  {
    id: "0x1c530D6de70c05A81bF1670157b9d928e9699089",
    version: "v1",
    name: "MEV Capital WBTC",
    symbol: "MCwBTC",
    asset: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
  },
  {
    id: "0xC0A14627D6a23f70c809777CEd873238581C1032",
    version: "v1",
    name: "MEV Capital USD0",
    symbol: "MC.USD0",
    asset: {
      address: "0x73A15FeD60Bf67631dC6cd7Bc5B6e8da8190aCF5",
      symbol: "USD0",
    },
  },
  {
    id: "0x225C119fFaf1CaddCfCDb493283eDF4b816Bf773",
    version: "v1",
    name: "MEV Capital Usual Boosted USDT",
    symbol: "USUALUSDT",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0xbEEfa1aBfEbE621DF50ceaEF9f54FdB73648c92C",
    version: "v1",
    name: "Steakhouse USDA",
    symbol: "steakUSDA",
    asset: {
      address: "0x0000206329b97DB379d5E1Bf586BbDB969C63274",
      symbol: "USDA",
    },
  },
  {
    id: "0xBEEFa260c2CE39122367cEAb0b4F94e6068cAcb6",
    version: "v1",
    name: "Steakhouse EURA",
    symbol: "steakEURA",
    asset: {
      address: "0x1a7e4e63778B4f12a199C062f3eFdD288afCBce8",
      symbol: "EURA",
    },
  },
  {
    id: "0xBeEf796ae50ba5423857CAc27DD36369cfc8241b",
    version: "v1",
    name: "Steakhouse PAXG",
    symbol: "steakPAXG",
    asset: {
      address: "0x45804880De22913dAFE09f4980848ECE6EcbAf78",
      symbol: "PAXG",
    },
  },
  {
    id: "0xBeEfDA19BC6114633FC17e6d074A6A2b472C756f",
    version: "v1",
    name: "Steakhouse USDS",
    symbol: "steakUSDS",
    asset: {
      address: "0xdC035D45d973E3EC169d2276DDab16f1e407384F",
      symbol: "USDS",
    },
  },
  {
    id: "0x98cF0B67Da0F16E1F8f1a1D23ad8Dc64c0c70E0b",
    version: "v1",
    name: "MEV Capital cbBTC",
    symbol: "MCcbBTC",
    asset: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0x0F359FD18BDa75e9c49bC027E7da59a4b01BF32a",
    version: "v1",
    name: "Relend USDC",
    symbol: "reUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x78B18E07dc43017fcEaabaD0751d6464c0F56b25",
    version: "v1",
    name: "Metronome msETH Vault",
    symbol: "gtmsETHc",
    asset: {
      address: "0x64351fC9810aDAd17A690E4e1717Df5e7e085160",
      symbol: "msETH",
    },
  },
  {
    id: "0xfbDEE8670b273E12b019210426E70091464b02Ab",
    version: "v1",
    name: "MEV Capital M^0 Vault",
    symbol: "MC.wM",
    asset: {
      address: "0x437cc33344a0B27A429f795ff6B469C72698B291",
      symbol: "wM",
    },
  },
  {
    id: "0xF587f2e8AfF7D76618d3B6B4626621860FbD54e3",
    version: "v1",
    name: "Gauntlet cbBTC Core",
    symbol: "gtcbBTCc",
    asset: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0xBEeFd1C0C6C1F7c94DC6b989DBA2E983A47A26A8",
    version: "v1",
    name: "Steakhouse USDL",
    symbol: "steakUSDL",
    asset: {
      address: "0x7751E2F4b8ae93EF6B79d86419d42FE3295A4559",
      symbol: "wUSDL",
    },
  },
  {
    id: "0xbEEFC01767ed5086f35deCb6C00e6C12bc7476C1",
    version: "v1",
    name: "Coinshift USDL",
    symbol: "csUSDL",
    asset: {
      address: "0x7751E2F4b8ae93EF6B79d86419d42FE3295A4559",
      symbol: "wUSDL",
    },
  },
  {
    id: "0x6188C18CB1c9Ef246aDf4454cC184a84A4Fc5465",
    version: "v1",
    name: "Vertex USDC Investment Grade",
    symbol: "vertexUSDCig",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xA02F5E93f783baF150Aa1F8b341Ae90fe0a772f7",
    version: "v1",
    name: "Re7 cbBTC",
    symbol: "Re7cbBTC",
    asset: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0x7526e974d8A8469d29EE606630215245287a07Bf",
    version: "v1",
    name: "Caramila Capital USDC",
    symbol: "ccmUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xB9C9158aB81f90996cAD891fFbAdfBaad733c8C6",
    version: "v1",
    name: "Relend cbBTC",
    symbol: "recbBTC",
    asset: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0x2f1aBb81ed86Be95bcf8178bA62C8e72D6834775",
    version: "v1",
    name: "Pendle WBTC",
    symbol: "pWBTC",
    asset: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
  },
  {
    id: "0x6859B34a9379122d25A9FA46f0882d434fee36c3",
    version: "v1",
    name: "Metronome msUSD Vault",
    symbol: "gtmsUSDc",
    asset: {
      address: "0xab5eB14c09D416F0aC63661E57EDB7AEcDb9BEfA",
      symbol: "msUSD",
    },
  },
  {
    id: "0xdC94785959B73F7A168452b3654E44fEc6A750e4",
    version: "v1",
    name: "Gauntlet LBTC Core",
    symbol: "gtLBTCc",
    asset: {
      address: "0x8236a87084f8B84306f72007F36F2618A5634494",
      symbol: "LBTC",
    },
  },
  {
    id: "0xBEEF6806363b51a90fFD1a632a8de32873b63a9E",
    version: "v1",
    name: "Steakhouse USDC RWA",
    symbol: "steakUSDCrwa",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xc554929a61d862F2741077F8aafa147479c0b308",
    version: "v1",
    name: "IndexCoop hyETH",
    symbol: "hyETH",
    asset: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0xBEeFFF209270748ddd194831b3fa287a5386f5bC",
    version: "v1",
    name: "Smokehouse USDC",
    symbol: "bbqUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xbeeFfF68CC520D68f82641EFF84330C631E2490E",
    version: "v1",
    name: "Smokehouse DAI",
    symbol: "bbqDAI",
    asset: {
      address: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
      symbol: "DAI",
    },
  },
  {
    id: "0x45c1875F1C48622b3D9740Af2D7dc62Bc9a72422",
    version: "v1",
    name: "Relend Gold",
    symbol: "reGOLD",
    asset: {
      address: "0x2103E845C5E135493Bb6c2A4f0B8651956eA8682",
      symbol: "XAUM",
    },
  },
  {
    id: "0xBD4073e6E929F197a9d18e22A68C276E8B400375",
    version: "v1",
    name: "ZAI Vault (MAHA.xyz)",
    symbol: "ZAIMorpho",
    asset: {
      address: "0x69000dFD5025E82f48Eb28325A2B88a241182CEd",
      symbol: "ZAI",
    },
  },
  {
    id: "0xC1d3e596984982bfBAefC85387107c26c319E465",
    version: "v1",
    name: "testUSDCVault2",
    symbol: "XXtestUSDc",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x2d8283b177D2e6AD92E09BDf13e10d1c2cE327d0",
    version: "v1",
    name: "APPX",
    symbol: "appx",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xa79a5fb6f619dA3ED71087Fb5cD33B16A5B666B5",
    version: "v1",
    name: "Nova fxUSD Vault",
    symbol: "nfxUSD",
    asset: {
      address: "0x085780639CC2cACd35E474e71f4d000e2405d8f6",
      symbol: "fxUSD",
    },
  },
  {
    id: "0x89610f2125A54547A7FB2A1B7926Be734A632255",
    version: "v1",
    name: "Nova WETH Vault",
    symbol: "nWETH",
    asset: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0xF94fC6A60f1FAd0fb9652df0e261bE7D9064C370",
    version: "v1",
    name: "Gauntlet USDT Prime",
    symbol: "gUSDT",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0x3E379e09F4a9a4617b5AE6C45288F01a3D278c7F",
    version: "v1",
    name: "TestPrimeUSDC",
    symbol: "TPUSDC",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0xBeeF7959aE71D4e45e1863dae0B94C35244AF816",
    version: "v1.1",
    name: "Steakhouse PAXG",
    symbol: "steakPAXG",
    asset: {
      address: "0x45804880De22913dAFE09f4980848ECE6EcbAf78",
      symbol: "PAXG",
    },
  },
  {
    id: "0xbEeFc011e94f43b8B7b455eBaB290C7Ab4E216f1",
    version: "v1.1",
    name: "Coinshift USDL",
    symbol: "csUSDL",
    asset: {
      address: "0x7751E2F4b8ae93EF6B79d86419d42FE3295A4559",
      symbol: "wUSDL",
    },
  },
  {
    id: "0x6D4e530B8431a52FFDA4516BA4Aadc0951897F8C",
    version: "v1.1",
    name: "Steakhouse USDC RWA",
    symbol: "steakUSDCrwa",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x08995EC16F3FAD0C357B3Da68Eee09A88932DEc0",
    version: "v1.1",
    name: "Steakhouse USDC Lite",
    symbol: "steakUSDClite",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x132E6C9C33A62D7727cd359b1f51e5B566E485Eb",
    version: "v1.1",
    name: "Resolv USDC",
    symbol: "resolvUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x701907283a57FF77E255C3f1aAD790466B8CE4ef",
    version: "v1.1",
    name: "Index Coop hyETH",
    symbol: "mhyETH",
    asset: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0x51056b3F809f4cFE17E1A8715B82f5dbbCA5a5A1",
    version: "v1.1",
    name: "MaxEarn USDC",
    symbol: "meUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x7204B7Dbf9412567835633B6F00C3Edc3a8D6330",
    version: "v1.1",
    name: "Coinshift USDC",
    symbol: "csUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x833AdaeF212c5cD3f78906B44bBfb18258F238F0",
    version: "v1.1",
    name: "Smokehouse WSTETH",
    symbol: "bbqWSTETH",
    asset: {
      address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
      symbol: "wstETH",
    },
  },
  {
    id: "0xA0804346780b4c2e3bE118ac957D1DB82F9d7484",
    version: "v1.1",
    name: "Smokehouse USDT",
    symbol: "bbqUSDT",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0x1e6ffa4e9F63d10B8820A3ab52566Af881Dab53c",
    version: "v1.1",
    name: "Gauntlet WETH Ecosystem",
    symbol: "gtWETHe",
    asset: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0x214B47C50057eFaa7adc1B1C2608C3751Cd77D78",
    version: "v1.1",
    name: "Apostro Resolv USDC",
    symbol: "aprUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xD5Ac156319f2491d4ad1Ec4aA5ed0ED48C0fa173",
    version: "v1.1",
    name: "9Summits USDC Core",
    symbol: "9SUSDCcore",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xE87ed29896B91421ff43f69257ABF78300e40c7a",
    version: "v1.1",
    name: "Re7 wstETH",
    symbol: "Re7wstETH",
    asset: {
      address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
      symbol: "wstETH",
    },
  },
  {
    id: "0x059Fc6723b9bF77DbF4283C8d7C90eA8Af44EF10",
    version: "v1.1",
    name: "SwissBorg tBTC",
    symbol: "sbMorphotBTC",
    asset: {
      address: "0x18084fbA666a33d37592fA2633fD49a74DD93a88",
      symbol: "tBTC",
    },
  },
  {
    id: "0x974c8FBf4fd795F66B85B73ebC988A51F1A040a9",
    version: "v1.1",
    name: "Hakutora USDC",
    symbol: "hUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xa71D08A159258553a5Ac190d60Fa919425Ff02EA",
    version: "v1.1",
    name: "Hakutora USDT",
    symbol: "hUSDT",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0x42D425Fb918acBbd73B10B851979E8fc469B3e9A",
    version: "v1.1",
    name: "Hakutora DAI",
    symbol: "hDAI",
    asset: {
      address: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
      symbol: "DAI",
    },
  },
  {
    id: "0x6ACa9D74215e9512d9608aFF3e87dac0d9ce6218",
    version: "v1.1",
    name: "Hakutora WETH",
    symbol: "hWETH",
    asset: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0xba04de02ED8cecc3befb8575a95d56D901c9C602",
    version: "v1.1",
    name: "Hakutora cbBTC",
    symbol: "hcbBTC",
    asset: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0xc82b74bC114D7e2D4047Ccf14f7a6109b654Ab91",
    version: "v1.1",
    name: "Hakutora WBTC",
    symbol: "hWBTC",
    asset: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
  },
  {
    id: "0x20b8020cC34F7105bE5605300FcCa00728f0a5d1",
    version: "v1.1",
    name: "MEV Capital USD0",
    symbol: "MC.USD0",
    asset: {
      address: "0x73A15FeD60Bf67631dC6cd7Bc5B6e8da8190aCF5",
      symbol: "USD0",
    },
  },
  {
    id: "0xD50DA5F859811A91fD1876C9461fD39c23C747Ad",
    version: "v1.1",
    name: "MEV Capital Resolv USR",
    symbol: "MC-USR",
    asset: {
      address: "0x66a1E37c9b0eAddca17d3662D6c05F4DECf3e110",
      symbol: "USR",
    },
  },
  {
    id: "0xdBB316375B4dC992B2c8827D120c09dFB1d3455D",
    version: "v1.1",
    name: "SolvBTC Babylon Vault",
    symbol: "msolvbtcbbn",
    asset: {
      address: "0xd9D920AA40f578ab794426F5C90F6C731D159DEf",
      symbol: "xSolvBTC",
    },
  },
  {
    id: "0x5085Dd6FAd07c12e38fae01bc2a4938d2C08B1Bc",
    version: "v1.1",
    name: "Apostro Resolv USR",
    symbol: "aprUSR",
    asset: {
      address: "0x66a1E37c9b0eAddca17d3662D6c05F4DECf3e110",
      symbol: "USR",
    },
  },
  {
    id: "0xA8875aaeBc4f830524e35d57F9772FfAcbdD6C45",
    version: "v1.1",
    name: "Gauntlet USDC RWA",
    symbol: "gtusdcrwa",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xc582F04d8a82795aa2Ff9c8bb4c1c889fe7b754e",
    version: "v1.1",
    name: "Gauntlet USDC Frontier",
    symbol: "gtusdcf",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x79FD640000F8563A866322483524a4b48f1Ed702",
    version: "v1.1",
    name: "Gauntlet USDT Frontier",
    symbol: "gtusdtf",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0x097FFEDb80d4b2Ca6105a07a4D90eB739C45A666",
    version: "v1.1",
    name: "Steakhouse USDT Lite",
    symbol: "steakUSDTlite",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0xA1b60d96e5C50dA627095B9381dc5a46AF1a9a42",
    version: "v1.1",
    name: "Steakhouse USDQ",
    symbol: "steakUSDQ",
    asset: {
      address: "0xc83e27f270cce0A3A3A29521173a83F402c1768b",
      symbol: "USDQ",
    },
  },
  {
    id: "0x30881Baa943777f92DC934d53D3bFdF33382cab3",
    version: "v1.1",
    name: "Steakhouse USDR",
    symbol: "steakUSDR",
    asset: {
      address: "0x7B43E3875440B44613DC3bC08E7763e6Da63C8f8",
      symbol: "USDR",
    },
  },
  {
    id: "0x75741A12B36D181f44F389E0c6B1E0210311e3Ff",
    version: "v1.1",
    name: "Steakhouse EURCV",
    symbol: "steakEURCV",
    asset: {
      address: "0x5F7827FDeb7c20b443265Fc2F40845B715385Ff2",
      symbol: "EURCV",
    },
  },
  {
    id: "0xa5aA40F27DAeDE9748822ef836170f202e196B5A",
    version: "v1.1",
    name: "Steakhouse M",
    symbol: "steakM",
    asset: {
      address: "0x437cc33344a0B27A429f795ff6B469C72698B291",
      symbol: "wM",
    },
  },
  {
    id: "0x67E23A4bc1195d66326D07609c3F20eD9a0B87E4",
    version: "v1.1",
    name: "Lumetra Opportunistic USDC",
    symbol: "lumenUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x0404fD1a77756EB029F06b5CDea88B2B2ddC2fEE",
    version: "v1.1",
    name: "Elixir USDC",
    symbol: "elixirUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x749794E985Af5a9A384B9cEe6D88DaB4CE1576A1",
    version: "v1.1",
    name: "MEV Capital USD0",
    symbol: "MC_USD0",
    asset: {
      address: "0x73A15FeD60Bf67631dC6cd7Bc5B6e8da8190aCF5",
      symbol: "USD0",
    },
  },
  {
    id: "0x47fe8Ab9eE47DD65c24df52324181790b9F47EfC",
    version: "v1.1",
    name: "ALPHA wETH Core",
    symbol: "aWETH",
    asset: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0xD50B9Bbf136D1BD5CD5AC6ed9b3F26c458a6d4A6",
    version: "v1.1",
    name: "(Deployer)",
    symbol: "adUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x8986cbE8b98C342888Aa2787C2979b6E32a40149",
    version: "v1.1",
    name: "Alpha USDC (Installer)",
    symbol: "aUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x0B6C8ef0DE1Be5ed1B59E6e7a67fB9442FB9E49C",
    version: "v1.1",
    name: "Duplicated Key",
    symbol: "DPK.Eth",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x777791C4d6DC2CE140D00D2828a7C93503c67777",
    version: "v1.1",
    name: "Hyperithm USDC Apex",
    symbol: "hyperUSDCa",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x3365184e87d2Bd75961780454A5810BEc956F0dD",
    version: "v1.1",
    name: "Gauntlet Olympus sUSDS Vault",
    symbol: "OHMsUSDS",
    asset: {
      address: "0xa3931d71877C0E7a3148CB7Eb4463524FEc27fbD",
      symbol: "sUSDS",
    },
  },
  {
    id: "0x59D9571A54593a5EC47d6A20837D96745ECF5C37",
    version: "v1.1",
    name: "Spectra USDC",
    symbol: "specUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xC59928341D08fEf900C6FA847fA9D775D27e482f",
    version: "v1.1",
    name: "SageFlow USDC Core",
    symbol: "sfUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x3FA495ecB30E4910bAC2a31818fd68d0DBb042a4",
    version: "v1.1",
    name: "SageFlow USDC Prime",
    symbol: "sfUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x00B6f2C15E4439749f192D10c70f65354848Cf4b",
    version: "v1.1",
    name: "9S Mount Kosciuszko USR",
    symbol: "9SUSR",
    asset: {
      address: "0x66a1E37c9b0eAddca17d3662D6c05F4DECf3e110",
      symbol: "USR",
    },
  },
  {
    id: "0x1E2aAaDcF528b9cC08F43d4fd7db488cE89F5741",
    version: "v1.1",
    name: "9Summits USDC",
    symbol: "9SUSDC11Core",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x59307D26FAc64FF9AEfA9371e00299521aA2263B",
    version: "v1.1",
    name: "Absolute Best WETH",
    symbol: "abweth",
    asset: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0xF1fd0D68B39FE514FD3dd3aE3BcC5FE4FE2Da0e6",
    version: "v1.1",
    name: "SageFlow USDT",
    symbol: "sfUSDT",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0x68Cae900D68BC148244663FCc15d896271020b81",
    version: "v1.1",
    name: "SageFlow ETH",
    symbol: "sfETH",
    asset: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0xDE0a65391f73aa130b7543AF2ce547Fd00Ec372a",
    version: "v1.1",
    name: "SageFlow DAI",
    symbol: "sfDAI",
    asset: {
      address: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
      symbol: "DAI",
    },
  },
  {
    id: "0xFa7ED49Eb24A6117D8a3168EEE69D26b45C40C63",
    version: "v1.1",
    name: "Alpha ZCHF Vault",
    symbol: "aZCHF",
    asset: {
      address: "0xB58E61C3098d85632Df34EecfB899A1Ed80921cB",
      symbol: "ZCHF",
    },
  },
  {
    id: "0x2C75C49c2807eEb8bbFBE1aD49eA543abBEe63d8",
    version: "v1.1",
    name: "Syntatic Staked USD Stratagies",
    symbol: "SyStUSD Stratagies",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0x6619F92861C760AD11BA0D56E8ED63A33EccE22B",
    version: "v1.1",
    name: "Alpha ZCHF Safe Vault",
    symbol: "asZCHF",
    asset: {
      address: "0xB58E61C3098d85632Df34EecfB899A1Ed80921cB",
      symbol: "ZCHF",
    },
  },
  {
    id: "0x64964E162Aa18d32f91eA5B24a09529f811AEB8e",
    version: "v1.1",
    name: "Re7 USDC Prime",
    symbol: "Re7USDCp",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xbEEF8DF2Ce4BaB5420123F9BF80dea4c65673257",
    version: "v1.1",
    name: "Smokehouse cbBTC",
    symbol: "bbqCBBTC",
    asset: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0xCcAbB9099bF5973d43288f217cF158348E3B9bB5",
    version: "v1.1",
    name: "Pangolins USDC",
    symbol: "pUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x5994cAAC1cc0EBE4D31e73dF46155c26D24B15Df",
    version: "v1.1",
    name: "Sakura USDC",
    symbol: "sakuraUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x4EDfaB296F8Eb15aC0907CF9eCb7079b1679Da57",
    version: "v1.1",
    name: "Apostro Ethena USDe",
    symbol: "aprUSDe",
    asset: {
      address: "0x4c9EDD5852cd905f086C759E8383e09bff1E68B3",
      symbol: "USDe",
    },
  },
  {
    id: "0x757eaFF4D8fAc610c60029522c433c47ae63199D",
    version: "v1.1",
    name: "cUSDO vault",
    symbol: "CUSDO",
    asset: {
      address: "0x8238884Ec9668Ef77B90C6dfF4D1a9F4F4823BFe",
      symbol: "USDO",
    },
  },
  {
    id: "0x01ff97514d77Bf3D1f989b382eC33C02F74038be",
    version: "v1.1",
    name: "Flagship USDC",
    symbol: "flagshipUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xD8FEaE012ffa83e6649c509F848Dc4bA0E4F3dfB",
    version: "v1.1",
    name: "Frontier USDC",
    symbol: "frontierUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xf1fd8AC6346eC7BC4116Ba7aDc81102B2BC4C52D",
    version: "v1.1",
    name: "MEV Capital USDC Prime",
    symbol: "MC_USDCP",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x2F21c6499fa53a680120e654a27640Fc8Aa40BeD",
    version: "v1.1",
    name: "OpenEden USDC Vault",
    symbol: "USDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xdef1Fce2df6270Fdf7E1214343BeBbaB8583D43d",
    version: "v1.1",
    name: "IMF USDS",
    symbol: "IMF-USDS",
    asset: {
      address: "0xdC035D45d973E3EC169d2276DDab16f1e407384F",
      symbol: "USDS",
    },
  },
  {
    id: "0xC5E96d92C156c5328aA7952Fd21D10349b91B434",
    version: "v1.1",
    name: "test-lvlusd",
    symbol: "testlvl",
    asset: {
      address: "0x7C1156E515aA1A2E851674120074968C905aAF37",
      symbol: "lvlUSD",
    },
  },
  {
    id: "0xbEEF36A5C1372F8D7d211527FCE9f83FE02d8A73",
    version: "v1.1",
    name: "Smokehouse ETH",
    symbol: "bbqETH",
    asset: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0xb0f05E4De970A1aaf77f8C2F823953a367504BA9",
    version: "v1.1",
    name: "ALPHA USDC Core",
    symbol: "aUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xbEEffF79FFA3EE2D1bfcC32dE9cFd8129528D0E4",
    version: "v1.1",
    name: "Safe x Smokehouse wstETH",
    symbol: "safe-bbqWSTETH",
    asset: {
      address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
      symbol: "wstETH",
    },
  },
  {
    id: "0xBeEFB45B6F9acB175e70acF16dC20D6120044c70",
    version: "v1.1",
    name: "Safe x Steakhouse ETH",
    symbol: "safe-steakETH",
    asset: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0xbEeFCe6c76C7D7A8066562Fe9FF0e343a52dD92F",
    version: "v1.1",
    name: "Safe x Steakhouse USDC",
    symbol: "safe-steakUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xBEeF47b9F76C9672B967A7b88d0afFf245Be13ad",
    version: "v1.1",
    name: "Safe x Steakhouse USDT",
    symbol: "safe-steakUSDT",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0x4427ceE946c626A60084000C2AbACCa9342FD8BD",
    version: "v1.1",
    name: "ee",
    symbol: "ee",
    asset: {
      address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
      symbol: "wstETH",
    },
  },
  {
    id: "0x2C3Cc1C02856894345797Cf6ee76aE76AC0f4031",
    version: "v1.1",
    name: "M11C Level lvlUSD",
    symbol: "M11C lvlUSD",
    asset: {
      address: "0x7C1156E515aA1A2E851674120074968C905aAF37",
      symbol: "lvlUSD",
    },
  },
  {
    id: "0xe12B879cE6Cd2B37dE0AE888F86a7b57FF26a212",
    version: "v1.1",
    name: "Yieldoor Vault",
    symbol: "yiUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x0562AE950276B24F3eAE0d0a518dADB7Ad2F8D66",
    version: "v1.1",
    name: "UltraYield USDC",
    symbol: "edgeUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x62fE596d59fB077c2Df736dF212E0AFfb522dC78",
    version: "v1.1",
    name: "Clearstar USDC Reactor",
    symbol: "CSUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xBEEFF900ec6faB1465252D2fBe731db8d1Ad5FD9",
    version: "v1.1",
    name: "Safe x Smokehouse WBTC",
    symbol: "safe-bbqWBTC",
    asset: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
  },
  {
    id: "0x888883f0eDDF69Ca4BfD00Af93714Ff97F188888",
    version: "v1.1",
    name: "Hyperithm USDT Core",
    symbol: "hyperUSDTc",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0x28d24D4380B26A1Ef305Ad8D8DB258159E472F33",
    version: "v1.1",
    name: "USUAL Vault",
    symbol: "USUAL_MV",
    asset: {
      address: "0xC4441c2BE5d8fA8126822B9929CA0b81Ea0DE38E",
      symbol: "USUAL",
    },
  },
  {
    id: "0x341193ED21711472e71aECa4A942123452bd0ddA",
    version: "v1.1",
    name: "Re7 USDC Core",
    symbol: "Re7USDCc",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x101b77d83c40207FA3A616E8b3aAeED166Dad03e",
    version: "v1.1",
    name: "Falcon USDC Prime",
    symbol: "fUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x05e13DE0ce29a9Df350EF54fE37a8729af06Ecc3",
    version: "v1.1",
    name: "Falcon USDT Prime",
    symbol: "fUSDT",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0xE89371eAaAC6D46d4C3ED23453241987916224FC",
    version: "v1.1",
    name: "Yearn OG WETH",
    symbol: "ymvOG-WETH",
    asset: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0x4d52545235A3dF246a8928c583E47AE7eeC4aCfE",
    version: "v1.1",
    name: "Re7 Falcon USDf",
    symbol: "Re7USDf",
    asset: {
      address: "0xFa2B947eEc368f42195f24F36d2aF29f7c24CeC2",
      symbol: "USDf",
    },
  },
  {
    id: "0xd4cD451d6f99AB9269FBfd0Ca7E2C9d1ebebe87a",
    version: "v1.1",
    name: "Ceres USDe Vault",
    symbol: "ceresUSDe",
    asset: {
      address: "0x4c9EDD5852cd905f086C759E8383e09bff1E68B3",
      symbol: "USDe",
    },
  },
  {
    id: "0x3DC15A363f5Dcf3B9dB90a5C0e2a5Cdf8f1CD77E",
    version: "v1.1",
    name: "Yearn OG DAI",
    symbol: "ymvOG-DAI",
    asset: {
      address: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
      symbol: "DAI",
    },
  },
  {
    id: "0x998D6B176eD2a57660cEb76d8421cDf00c752a8c",
    version: "v1.1",
    name: "Elixir sUSDS Vault",
    symbol: "exsUSDS",
    asset: {
      address: "0xa3931d71877C0E7a3148CB7Eb4463524FEc27fbD",
      symbol: "sUSDS",
    },
  },
  {
    id: "0xef0B6b77E014A9EB897b56466ea53175E14B9F34",
    version: "v1.1",
    name: "YLV USDC",
    symbol: "YLV-USDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x8fE7B529B89e06d6c17BBCE7b096Df4fE34455AA",
    version: "v1.1",
    name: "Kinto USDC",
    symbol: "kinto-usdc",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xa281f2Ded799e63f2dBa12164824DD1Ea8d39B24",
    version: "v1.1",
    name: "BT-IB01-Vault",
    symbol: "BTIB01V",
    asset: {
      address: "0x09896Fed3a813E6c3512E455972CeCD8D703055a",
      symbol: "IB01.bt",
    },
  },
  {
    id: "0xbEEf11C63d7173BdCC2037e7220eE9Bd0cCDA862",
    version: "v1.1",
    name: "Steakhouse Level USDC",
    symbol: "steakUSDClevel",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x3c124fB80e6eedD88D108C2F04013AE5CD571Abc",
    version: "v1.1",
    name: "Falcon USDf Core",
    symbol: "fUSDf",
    asset: {
      address: "0xFa2B947eEc368f42195f24F36d2aF29f7c24CeC2",
      symbol: "USDf",
    },
  },
  {
    id: "0x889dd190bB6b0662DB3fE0AAc29eEDCa3D2ba22A",
    version: "v1.1",
    name: "MEV Elixir sUSDS",
    symbol: "MC_sUSDS",
    asset: {
      address: "0xa3931d71877C0E7a3148CB7Eb4463524FEc27fbD",
      symbol: "sUSDS",
    },
  },
  {
    id: "0xf79F51f8F473eD34f6b2b13ee74c3208286D53EB",
    version: "v1.1",
    name: "Avantgarde WETH Core",
    symbol: "AVGWETHCORE",
    asset: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0x5b56F90340dBAa6a8693DADb141D620f0e154fE6",
    version: "v1.1",
    name: "Avantgarde USDC Core",
    symbol: "AVGUSDCCORE",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x48ee006b5CA63863Bb550F63C78cE36862C42074",
    version: "v1.1",
    name: "Best Return USDC",
    symbol: "BestUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x92Da51BE45A9a4002E0f85C5443D95602fCBbf7F",
    version: "v1.1",
    name: "USDC Dojo",
    symbol: "USDC DOJO",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xb5e4576C2FAA16b0cC59D1A2f3366164844Ef9E0",
    version: "v1.1",
    name: "Turtle cbBTC",
    symbol: "tacCBBTC",
    asset: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0x91af035b1C43bEf2cb3d6E2A4CEbD800852F03c3",
    version: "v1.1",
    name: "USUAL Vault",
    symbol: "USUAL_RIMU",
    asset: {
      address: "0xC4441c2BE5d8fA8126822B9929CA0b81Ea0DE38E",
      symbol: "USUAL",
    },
  },
  {
    id: "0x0bB2751a90fFF62e844b1521637DeD28F3f5046A",
    version: "v1.1",
    name: "Turtle ETH",
    symbol: "9SETHCore",
    asset: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0x64a4fb7Ab60fC4A7E52960DF0F1dcae06675aae9",
    version: "v1.1",
    name: "Gnomé Capital USUAL Vault",
    symbol: "gnoméUSUAL",
    asset: {
      address: "0xC4441c2BE5d8fA8126822B9929CA0b81Ea0DE38E",
      symbol: "USUAL",
    },
  },
  {
    id: "0xBEefb9f61CC44895d8AEc381373555a64191A9c4",
    version: "v1.1",
    name: "Vault Bridge USDC",
    symbol: "vbshUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x31A5684983EeE865d943A696AAC155363bA024f9",
    version: "v1.1",
    name: "Vault Bridge WETH",
    symbol: "vbgtWETH",
    asset: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0xc54b4E08C1Dcc199fdd35c6b5Ab589ffD3428a8d",
    version: "v1.1",
    name: "Vault Bridge USDT",
    symbol: "vbgtUSDT",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0x812B2C6Ab3f4471c0E43D4BB61098a9211017427",
    version: "v1.1",
    name: "Vault Bridge WBTC",
    symbol: "vbgtWBTC",
    asset: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
  },
  {
    id: "0xBeEFC1CDAfc5b4a649b54D07AFc6bF0f75C6F4E2",
    version: "v1.1",
    name: "Steakhouse Ethena USDtb",
    symbol: "steakUSDTBethena",
    asset: {
      address: "0xC139190F447e929f090Edeb554D95AbB8b18aC1C",
      symbol: "USDtb",
    },
  },
  {
    id: "0xbdbF0494Af9826ba25bcb810e23C36Bc6D8378fA",
    version: "v1.1",
    name: "Dream Charity Vault",
    symbol: "dreamUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xd41830d88dfD08678b0B886E0122193d54b02Acc",
    version: "v1.1",
    name: "MEV Capital PTs USDC",
    symbol: "MC_PTs",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xEF8C049Df1e798FEc8645709867966410a711941",
    version: "v1.1",
    name: "PEPE",
    symbol: "PEPE/USDC",
    asset: {
      address: "0x6982508145454Ce325dDbE47a25d4ec3d2311933",
      symbol: "PEPE",
    },
  },
  {
    id: "0xe2a8c78cBC766b1D472e0Bc52D5c1e512BCa2C1c",
    version: "v1.1",
    name: "Private Kitchen USR vault",
    symbol: "PKUSRV",
    asset: {
      address: "0x66a1E37c9b0eAddca17d3662D6c05F4DECf3e110",
      symbol: "USR",
    },
  },
  {
    id: "0x6D84E690150bf1B0F99e6CF02C7a1fE352489713",
    version: "v1.1",
    name: "USDC Private Vault",
    symbol: "USCD_OFFICE",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x30A4fB0c64313613c3633807971482eDf3182618",
    version: "v1.1",
    name: "JUSD vault test",
    symbol: "JUSD Vault test",
    asset: {
      address: "0x000000096CB3D4007fC2b79b935C4540C5c2d745",
      symbol: "jUSD",
    },
  },
  {
    id: "0xcb7E96E1d4DFe35Ac674AF5Fa121Bcd9B0AAb1b1",
    version: "v1.1",
    name: "Jigsaw LEVEL Flywheel",
    symbol: "JUSD LVLUSD",
    asset: {
      address: "0x7C1156E515aA1A2E851674120074968C905aAF37",
      symbol: "lvlUSD",
    },
  },
  {
    id: "0x109eDC846C98BB468a79AFdB4688a519416f1Dc4",
    version: "v1.1",
    name: "WrytLabs EURC",
    symbol: "wvEURC",
    asset: {
      address: "0x1aBaEA1f7C830bD89Acc67eC4af516284b1bC33c",
      symbol: "EURC",
    },
  },
  {
    id: "0xE01813b0A12B14CC13BD5E9F0E8a2Aa7543617a1",
    version: "v1.1",
    name: "High Yield USDC",
    symbol: "HYUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x103085e1aa4E8D7A41045B5CBe472EF5301C93B4",
    version: "v1.1",
    name: "Stackup USDC",
    symbol: "suUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xeBb1ce9c7c18f0AB128e711B4f5C3C20fEB1f158",
    version: "v1.1",
    name: "MVL USDC",
    symbol: "mvlUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x68Aea7b82Df6CcdF76235D46445Ed83f85F845A3",
    version: "v1.1",
    name: "Yearn USDC",
    symbol: "oevUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x9D4B8BBe39E42F371bE3dbC86Ea6e6B34F123B11",
    version: "v1.1",
    name: "TEST USDC CS",
    symbol: "TESTCSUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xDA4063Ec62c3F3c1D2BdBf7Dbfb2b2C906f8E8b2",
    version: "v1.1",
    name: "MEV Capital USDT",
    symbol: "MC_USDT",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0xF9bdDd4A9b3A45f980e11fDDE96e16364dDBEc49",
    version: "v1.1",
    name: "Yearn OG USDC",
    symbol: "ymvOG-USDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xbEEf390D2e65d6E43A67875106d4A48f700F2832",
    version: "v1.1",
    name: "Safe x Smokehouse USDC",
    symbol: "safe-bbqUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xbEEf0c18715ACDdC14a3123a608F491319F1C28C",
    version: "v1.1",
    name: "Safe x Smokehouse USDT",
    symbol: "safe-bbqUSDT",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0xfBC84DBfAA2196853FdB6cAE52ef8F56DD76770a",
    version: "v1.1",
    name: "BOLD Reactor",
    symbol: "BOLDCS",
    asset: {
      address: "0x6440f144b7e50D6a8439336510312d2F54beB01D",
      symbol: "BOLD",
    },
  },
  {
    id: "0x80b82A65d5E081272b00065d545eb09aDf68B989",
    version: "v1.1",
    name: "Test",
    symbol: "Test",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xb12376f591622975E85422D0ab5616dA273df97a",
    version: "v1.1",
    name: "Inverse Finance TWG USDC",
    symbol: "INV TWG USDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xD3468749951Ed99566c528CCcF56dB3d23BDdF43",
    version: "v1.1",
    name: "SingularV USDC",
    symbol: "svUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x739d8a60ED4b14E4cB6DCAEAF79d2ec0Ca092237",
    version: "v1.1",
    name: "SingularV ETH",
    symbol: "svETH",
    asset: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0x38248d715336d4CAd20d3e12E8dc34DA596f9d6c",
    version: "v1.1",
    name: "RIMU USDC",
    symbol: "RIMUusdc",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x9646eBD6346C8C3a9f3d408f71C312eB0CbE8507",
    version: "v1.1",
    name: "Pendlend USDT",
    symbol: "penUSDT",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0xcbd3f67d660b5485Cc872Dfa31CdBe5C03101E89",
    version: "v1.1",
    name: "Super USDC Vault",
    symbol: "SUV",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x2ed10624315b74a78f11FAbedAa1A228c198aEfB",
    version: "v1.1",
    name: "Gauntlet EURC Core",
    symbol: "gteurcc",
    asset: {
      address: "0x1aBaEA1f7C830bD89Acc67eC4af516284b1bC33c",
      symbol: "EURC",
    },
  },
  {
    id: "0xcE22b5Fb17ccbc0C5d87DC2e0dF47DD71E3AdC0a",
    version: "v1.1",
    name: "USDU Core",
    symbol: "sUSDu",
    asset: {
      address: "0xdde3eC717f220Fc6A29D6a4Be73F91DA5b718e55",
      symbol: "USDU",
    },
  },
  {
    id: "0x0B5281e1fa7fC7c1f0890F311d5f04D55c0Fd63c",
    version: "v1.1",
    name: "USDU Staked",
    symbol: "sUSDu+",
    asset: {
      address: "0xcE22b5Fb17ccbc0C5d87DC2e0dF47DD71E3AdC0a",
      symbol: "sUSDu",
    },
  },
  {
    id: "0xbdd4859050468fBc11Dec07113a6e633608A1372",
    version: "v1.1",
    name: "SingularV USDT",
    symbol: "svUSDT",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0xcB82e29930835A937429D4BCAD0a6fa6636755D7",
    version: "v1.1",
    name: "Adpend",
    symbol: "ADP",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xdC2Dd5189F70Fe2832D9caf7b17d27AA3D79dbE1",
    version: "v1.1",
    name: "Yearn Degen USDC",
    symbol: "yDG-USDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xa00A5B20F487D0113784F85FBa88db66a408F1e0",
    version: "v1.1",
    name: "August USDC",
    symbol: "agUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xBEeF1f5Bd88285E5B239B6AAcb991d38ccA23Ac9",
    version: "v1.1",
    name: "Steakhouse infiniFi USDC",
    symbol: "steakUSDCinfinifi",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xbeEfdDbd3bef4726bCF9627a9BA3B901D4958745",
    version: "v1.1",
    name: "Steakhouse Ethena USDT",
    symbol: "steakUSDTethena",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0x5440Ea551935782fE87FE7BdBE9C4A101755179B",
    version: "v1.1",
    name: "USDC Vault",
    symbol: "yUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x515d0e660E02C2c149a025d47f352EE6cB236B93",
    version: "v1.1",
    name: "Spark USDS Vault",
    symbol: "sparkUSDS",
    asset: {
      address: "0xdC035D45d973E3EC169d2276DDab16f1e407384F",
      symbol: "USDS",
    },
  },
  {
    id: "0xe41a0583334f0dc4E023Acd0bFef3667F6FE0597",
    version: "v1.1",
    name: "Spark USDS Vault",
    symbol: "sparkUSDS",
    asset: {
      address: "0xdC035D45d973E3EC169d2276DDab16f1e407384F",
      symbol: "USDS",
    },
  },
  {
    id: "0x965Ec3552427B8258BD0a0c7baA234618fc98D01",
    version: "v1.1",
    name: "UltraYield USDT",
    symbol: "edgeUSDT",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0x2Ccb3717b04Df3603b1471738d4d500Fa8e57b85",
    version: "v1.1",
    name: "Ellen Capital - USDC Aggressive",
    symbol: "Ellen01",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x5a545AB9D7d08Aa8625bf78CB8EB1080b0393cf8",
    version: "v1.1",
    name: "UltraYield WETH",
    symbol: "edgeWETH",
    asset: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0x55555815a5595991C3A0Ff119B59AEF6C8B55555",
    version: "v1.1",
    name: "Adpend USDC",
    symbol: "adpUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xB2d9F816e615cdAB2d0Bd201DCcb650CDFC44134",
    version: "v1.1",
    name: "TestingVault",
    symbol: "TESTINGUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x38Bc32F98c6D5C2Bb8c743a4Aa364b4F529fD1Ac",
    version: "v1.1",
    name: "Secretweapon USDC",
    symbol: "sweapUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x40DD8f13395a1dD5C8aB5B6a7ecDb4F782838E45",
    version: "v1.1",
    name: "Spectra Ecosystem",
    symbol: "SPCSUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x0C36327e93F749a7eec04603410dF776150f47DE",
    version: "v1.1",
    name: "ABRC",
    symbol: "abrc",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xD6816A95FE4A1dc5Df7ae62f257e83c11d617788",
    version: "v1.1",
    name: "StableMax USDT Vault",
    symbol: "MaxUSDT",
    asset: {
      address: "0x9F56094C450763769BA0EA9Fe2876070c0fD5F77",
      symbol: "PT-sUSDE-25SEP2025",
    },
  },
  {
    id: "0x6BCD56D505843a96a3e026942033486a6c0bAaf2",
    version: "v1.1",
    name: "ABCOE",
    symbol: "ABCOE",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x48889608059f5c83041fe701580FF4DDDF737E4d",
    version: "v1.1",
    name: "Adpend ETH",
    symbol: "adpETH",
    asset: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0xCdaea3dde6cE5969aA1414A82A3A681cEd51Ce72",
    version: "v1.1",
    name: "Hyperithm USDC Core",
    symbol: "hyperUSDCc",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x83b779E6eC421a676a9A20743679914680A928f9",
    version: "v1.1",
    name: "Hyperithm Bastion USDT",
    symbol: "hyperBastionUSDT",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0x6D6D386C4855d9b604D7E14c70526407F6272394",
    version: "v1.1",
    name: "Hyperithm ETH Apex",
    symbol: "hyperETHa",
    asset: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0xf8Db59ad207b34DB4E028fA03CbCef5F75214E38",
    version: "v1.1",
    name: "StableMax Vault",
    symbol: "MUSDT",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0x973f758aA6C15bafa8bBEFfD4b9449F5b5885edD",
    version: "v1.1",
    name: "Notional USDC",
    symbol: "n-USDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xbeEf96B330ef1Fe7Ebe41eCe0Bd4a41A94Bc03DC",
    version: "v1.1",
    name: "Cronos USDC",
    symbol: "cronosUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x7802B8C35bFCB5B9a44a8dcC135b8Fda0fEd70F3",
    version: "v1.1",
    name: "StableMax Vault",
    symbol: "MUSDT",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0xAe86261C403E8Da7B71Dcd3343ED9F1c8A972d63",
    version: "v1.1",
    name: "Ellen Capital - USDC Safe",
    symbol: "ellenUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x1941aDa601B91Ea7538E73442a1a632E8F9Ffb70",
    version: "v1.1",
    name: "Pangolins USDC",
    symbol: "pUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xd73270593E2542e5A43b8c7FBE4F2d5c9c4A443c",
    version: "v1.1",
    name: "Pangolins USDT",
    symbol: "pUSDT",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0xca7c196f00e04A5e1c71B91476d0d58f82499734",
    version: "v1.1",
    name: "Tanken USDC",
    symbol: "tkUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xfeaC08ffA38d95ec5Ed7C46c933C8891a44C5F26",
    version: "v1.1",
    name: "Spark Blue Chip USDC Vault",
    symbol: "sparkUSDCbc",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x4339C355728327852Fcd4c142fE87C06371E795C",
    version: "v1.1",
    name: "natural intelligence",
    symbol: "TEESTEEETT",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xF03F45AFB809412649Bfb879105517e39e28d406",
    version: "v1.1",
    name: "Sberex USDC",
    symbol: "sbxUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xBBfaF69e3B932f38541a130CD5f3cB0e7100Fa0d",
    version: "v1.1",
    name: "Sberex EURC",
    symbol: "sbxEURC",
    asset: {
      address: "0x1aBaEA1f7C830bD89Acc67eC4af516284b1bC33c",
      symbol: "EURC",
    },
  },
  {
    id: "0x76deDAf4Ec78777716BdEba484037C9d5fBF5D11",
    version: "v1.1",
    name: "Alpha USDT Core",
    symbol: "aUSDT",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0xDCD35020c5bB97016358578131f012Baa9F53cf3",
    version: "v1.1",
    name: "dForce USDC",
    symbol: "dForce USDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xc2007A9c48Eecb36868Cf9D1da5D8566e90bf042",
    version: "v1.1",
    name: "dForce USDT",
    symbol: "dForce USDT",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0x90880852B607065152360aB718b8a7a6bA979281",
    version: "v1.1",
    name: "dForce WETH",
    symbol: "dForce WETH",
    asset: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0xda4D1A3187Eba9Ecaa137867bD4541f78D51638e",
    version: "v1.1",
    name: "Alpha MUSD Core",
    symbol: "aMUSD",
    asset: {
      address: "0xdD468A1DDc392dcdbEf6db6e34E89AA338F9F186",
      symbol: "MUSD",
    },
  },
  {
    id: "0x2D9926E6a6B84476ed5718972159F3e4B33DbCCd",
    version: "v1.1",
    name: "S Vault me",
    symbol: "SVMEe",
    asset: {
      address: "0xdC035D45d973E3EC169d2276DDab16f1e407384F",
      symbol: "USDS",
    },
  },
  {
    id: "0x7C3f446cBC012aebEb21e9Fe66e69AE312f87cc1",
    version: "v1.1",
    name: "CoinVertible EURCV",
    symbol: "mevEURCV",
    asset: {
      address: "0x5F7827FDeb7c20b443265Fc2F40845B715385Ff2",
      symbol: "EURCV",
    },
  },
  {
    id: "0x56A76b428244a50513ec81e225a293d128fd581D",
    version: "v1.1",
    name: "Spark Blue Chip USDC Vault",
    symbol: "sparkUSDCbc",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x7777773E9C2635B0c78A189Bb81D7540CD777777",
    version: "v1.1",
    name: "Adpend ETH",
    symbol: "adpETH",
    asset: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0x5Dc3Bd5a89E033e8ae54B6e5AE967C98EdB5B4c4",
    version: "v1.1",
    name: "M11C USDC",
    symbol: "M11C USDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xFDe988570C0440Fc49FFEF4b0355bE53C879885b",
    version: "v1.1",
    name: "DBD Labs",
    symbol: "DBD",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x7f838C4c70B841A4979aF44053c8965f4694F9E5",
    version: "v1.1",
    name: '"><img src=x onerror=alert()>',
    symbol: '"><img src=x onerror=alert()>',
    asset: {
      address: "0xBEEF01735c132Ada46AA9aA4c54623cAA92A64CB",
      symbol: "steakUSDC",
    },
  },
  {
    id: "0x05BbAbbbAE447129A03d3B36c7D6e62fECD2Cee5",
    version: "v1.1",
    name: "DreyAnd USDC",
    symbol: "mvUSDC-DREY",
    asset: {
      address: "0xBEEF01735c132Ada46AA9aA4c54623cAA92A64CB",
      symbol: "steakUSDC",
    },
  },
  {
    id: "0xe108fbc04852B5df72f9E44d7C29F47e7A993aDd",
    version: "v1.1",
    name: " kpk USDC Prime",
    symbol: "kpk_USDC_Prime",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x018f8f5F52AAfF23FF838aE4637aFe22713FB428",
    version: "v1.1",
    name: "Hadjime USDC Prime",
    symbol: "USDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xd4e95092a8f108728c49f32A30f30556896563b5",
    version: "v1.1",
    name: "USDT Yield",
    symbol: "kpkUSDT",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0x0c6aec603d48eBf1cECc7b247a2c3DA08b398DC1",
    version: "v1.1",
    name: " kpk EURC Yield",
    symbol: "kpk_EURC_Yield",
    asset: {
      address: "0x1aBaEA1f7C830bD89Acc67eC4af516284b1bC33c",
      symbol: "EURC",
    },
  },
  {
    id: "0xB24704424191943dC5BB9aFE7C4EeD0fC4b1fA72",
    version: "v1.1",
    name: "Lightec Labs NanoStrategy for zkBTC",
    symbol: "LLNS-zkBTC",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0xf29ce940178C8794802fB48a6c1B2EdDdAC96431",
    version: "v1.1",
    name: "Lulo USDC",
    symbol: "luloUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x73Ea4fff78a427d8b9bd77216aF4c42e78E2F5b8",
    version: "v1.1",
    name: "GTEST 1.0",
    symbol: "GTEST",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x9cAF2EC3c6E9d9Af0447bDa6f24EAc60745E9a2a",
    version: "v1.1",
    name: "USDT Yield Testing",
    symbol: "USDTesting",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0x4529437099Ad37ba6fc87d6e11d233f7fc8Fc0F1",
    version: "v1.1",
    name: "EURCTestingVault",
    symbol: "EURCTesting",
    asset: {
      address: "0x1aBaEA1f7C830bD89Acc67eC4af516284b1bC33c",
      symbol: "EURC",
    },
  },
  {
    id: "0x9861937124611b0B674b18c640e73480f10A5213",
    version: "v1.1",
    name: "Saturn Vault",
    symbol: "STRN",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xd1aE35a2D9249Bf72EB9319DCE2b7658bE106A83",
    version: "v1.1",
    name: "MHILBTC",
    symbol: "MHILBTC",
    asset: {
      address: "0x88563b651ABF39D5e24d8210bcAB62014A504108",
      symbol: "HilBTC",
    },
  },
  {
    id: "0x52317a47585A6ACDfbD7a29B494c3E2baAE96aBc",
    version: "v1.1",
    name: "Alpha MUSD",
    symbol: "aMUSD",
    asset: {
      address: "0xdD468A1DDc392dcdbEf6db6e34E89AA338F9F186",
      symbol: "MUSD",
    },
  },
  {
    id: "0x9eFC6415af8f07d0D757C9F7c75251e33170fF0F",
    version: "v1.1",
    name: "EURCV Prime",
    symbol: "sgEURCV",
    asset: {
      address: "0x5F7827FDeb7c20b443265Fc2F40845B715385Ff2",
      symbol: "EURCV",
    },
  },
  {
    id: "0xA2284171d67575934f7CB8fd9446b0a4996eAdB1",
    version: "v1.1",
    name: "USDCV Prime",
    symbol: "sgUSDCV",
    asset: {
      address: "0x5422374B27757da72d5265cC745ea906E0446634",
      symbol: "USDCV",
    },
  },
  {
    id: "0x5593bf07cB1aDa24462EF23240c530441BBAd3e8",
    version: "v1.1",
    name: "USDCV Prime",
    symbol: "sgfUSDCV",
    asset: {
      address: "0x5422374B27757da72d5265cC745ea906E0446634",
      symbol: "USDCV",
    },
  },
  {
    id: "0x34eCe536d2ae03192B06c0A67030D1Faf4c0Ba43",
    version: "v1.1",
    name: "EURCV Prime",
    symbol: "sgfEURCV",
    asset: {
      address: "0x5F7827FDeb7c20b443265Fc2F40845B715385Ff2",
      symbol: "EURCV",
    },
  },
  {
    id: "0xd663fBF4F1ab3B555A2E6a1485306A4b0F89518d",
    version: "v1.1",
    name: "Relend USDT",
    symbol: "reUSDT",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0xF62f6060CB3833Daeb61b6AD960d6d531A0867d2",
    version: "v1.1",
    name: "Alpha WETH (installer)",
    symbol: "aiWETH",
    asset: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0x987FE7691bd513B03ea90392cAE37675CE0293Fb",
    version: "v1.1",
    name: "My Cool W Vault",
    symbol: "MyCool-W",
    asset: {
      address: "0xB0fFa8000886e57F86dd5264b9582b2Ad87b2b91",
      symbol: "W",
    },
  },
  {
    id: "0x8F40e713a1Cfeff2A052E0c610C8118Be3f75b12",
    version: "v1.1",
    name: "Clearstar Institutional USDC",
    symbol: "CSINSTUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xc5C44cB3fF1450B5325f212E02ffdfe5c92cf2Cf",
    version: "v1.1",
    name: "Notional WETH",
    symbol: "n-WETH",
    asset: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0x425651EA3ab6240A317794579ed62fcF7E7E817e",
    version: "v1.1",
    name: "Cypher Capital USDC",
    symbol: "Cypher",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xC004b0C1eaeA96d3ea0A08C2f0eFAa0DF93B6450",
    version: "v1.1",
    name: "Syntropia USDC",
    symbol: "synUSD",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xdEF169B328eaE0d27Ea9D74053fAa0B733F3Bbb6",
    version: "v1.1",
    name: "IMF wstETH",
    symbol: "IMF-wstETH",
    asset: {
      address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
      symbol: "wstETH",
    },
  },
  {
    id: "0xbEef11A6Ca3C67bbEa90e5601beDBE78832dd789",
    version: "v1.1",
    name: "Steakhouse USDCV",
    symbol: "steakUSDCV",
    asset: {
      address: "0x5422374B27757da72d5265cC745ea906E0446634",
      symbol: "USDCV",
    },
  },
  {
    id: "0x6C26793c7F1e2785c09b460676e797b716f0Bc8E",
    version: "v1.1",
    name: "Keyrock USDC",
    symbol: "kUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x6EA03c62a5d63AEFa4b9289c727CB5341Aa615a4",
    version: "v1.1",
    name: "Onyx XCN Vault",
    symbol: "vXCN",
    asset: {
      address: "0xA2cd3D43c775978A96BdBf12d733D5A1ED94fb18",
      symbol: "XCN",
    },
  },
  {
    id: "0xC8D921298D59187e8a46e0072D2e9B3B2F9190b3",
    version: "v1.1",
    name: "Arb Capital CANA/USDT MetaVault",
    symbol: "ARB-CANAUSDT-V1",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0x3f604074F3F12Ff70c29e6bCC9232c707DC4D970",
    version: "v1.1",
    name: "Blue Chip USDC Vault (Prime)",
    symbol: "PRIME",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xeDc72B49542E4362c677b8369bC23882Ed635A75",
    version: "v1.1",
    name: "Nucleon USDS",
    symbol: "NUSDS",
    asset: {
      address: "0xdC035D45d973E3EC169d2276DDab16f1e407384F",
      symbol: "USDS",
    },
  },
  {
    id: "0x98bF4be2415e405ac902ac5dCb197f68AAcBBB65",
    version: "v1.1",
    name: "Wrapped ETH",
    symbol: "WETH",
    asset: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0x7286193fE6077bfd9bD69715C832EB48c55DF01f",
    version: "v1.1",
    name: "Optimex USDC",
    symbol: "Optimex USDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xCEaa95811FA0651C04A0F0b4D454C5F1a8556a5F",
    version: "v1.1",
    name: "Cypher Capital Core USDC",
    symbol: "CyUSD",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x4F2ba48FaF0bA42c4E4b7871d3861418c83aE568",
    version: "v1.1",
    name: "SovaBase USDC",
    symbol: "Sova USDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xbF34DE704C23E3Ad125c3f5e1510dadcd27B298D",
    version: "v1.1",
    name: "Clearstar Institutional USDT",
    symbol: "CSINSTUSDT",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0xB8C9Ae462626Ec6162645F3E7e3441E7918c89F0",
    version: "v1.1",
    name: "Bandit USDC",
    symbol: "BUSDCV",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xBEEf2B5FD3D94469b7782aeBe6364E6e6FB1B709",
    version: "v1.1",
    name: "Grove x Steakhouse USDC High Yield",
    symbol: "grove-bbqUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x2E87d6bfA3F2A932e0c70A32607c0B839404984D",
    version: "v1.1",
    name: "Pocky's High Yield USDS",
    symbol: "PUSDSHY",
    asset: {
      address: "0xdC035D45d973E3EC169d2276DDab16f1e407384F",
      symbol: "USDS",
    },
  },
  {
    id: "0x5285047B35b357157f3948925ac604FcCa4850a8",
    version: "v1.1",
    name: "Sberex USDCV",
    symbol: "sbxUSDCV",
    asset: {
      address: "0x5422374B27757da72d5265cC745ea906E0446634",
      symbol: "USDCV",
    },
  },
  {
    id: "0x420690B889D474771539521B3d8C2aE276BA3880",
    version: "v1.1",
    name: "IMF WETH",
    symbol: "IMF-WETH",
    asset: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0xfD1241C4fc37680De370dDc20eBF7bC5e561E1c1",
    version: "v1.1",
    name: "Dune USDC",
    symbol: "duneUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xd564F765F9aD3E7d2d6cA782100795a885e8e7C8",
    version: "v1.1",
    name: "kpk ETH Prime",
    symbol: "kpk_ETH_Prime",
    asset: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0x234E5AE16eDf321AB5c2DDeBb0CCdf05aACb233b",
    version: "v1.1",
    name: "testWETHvault",
    symbol: "testWETH",
    asset: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0xB83ddaAC0dE644E5778dEA84d3C3480A0F6C8bAA",
    version: "v1.1",
    name: "Test USDS V1 Vault",
    symbol: "TUSDSV1V",
    asset: {
      address: "0xdC035D45d973E3EC169d2276DDab16f1e407384F",
      symbol: "USDS",
    },
  },
  {
    id: "0x79970dbE7bd03958fA442Bdd041A51a68946ce2C",
    version: "v1.1",
    name: "CPT48 USDS Selection",
    symbol: "CPT48",
    asset: {
      address: "0xdC035D45d973E3EC169d2276DDab16f1e407384F",
      symbol: "USDS",
    },
  },
  {
    id: "0x786977528B0265C5C5Bc9544ac56C863c03e34D1",
    version: "v1.1",
    name: "Longtail Strategy USDS",
    symbol: "LTSTRAT-USDS",
    asset: {
      address: "0xdC035D45d973E3EC169d2276DDab16f1e407384F",
      symbol: "USDS",
    },
  },
  {
    id: "0xF8899E64Bb269Cd333a486A70ea883Dd0E2FD451",
    version: "v1.1",
    name: "MorphoVault",
    symbol: "MV",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x94643e86aa5E38DDAc6c7791C1297f4E40cD96c1",
    version: "v1.1",
    name: "1337 USDC",
    symbol: "1337USDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x39Ae00999470c00E1f10603eDa39f0F1b1E979E7",
    version: "v1.1",
    name: "Bachata USDC",
    symbol: "bachata_USDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x9B5E92fd227876b4C07a8c02367E2CB23c639DfA",
    version: "v1.1",
    name: "Clearstar Yield USDC",
    symbol: "CSYUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x252c546687e45463DC3061e7Fb710f1673a975eC",
    version: "v1.1",
    name: "1337 ETH",
    symbol: "1337ETH",
    asset: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0x8c69f21B1b4822bfDe1f0700D70E6Ec97A27B8a5",
    version: "v1.1",
    name: "Dapp-Learning-Vault",
    symbol: "DLV",
    asset: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0xa3fC33543bEee52bC60bAbC80aF3d29789637B6D",
    version: "v1.1",
    name: "Clearstar Reactor ETH",
    symbol: "CSWETH",
    asset: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0x3a02F089f212dAEF4E54ec2616FFf71952A74B15",
    version: "v1.1",
    name: "Zharta Prime Baseline USDC",
    symbol: "USDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xc02Aabef00f0571E27bB66Cc37c7057e1A850cC2",
    version: "v1.1",
    name: "Morph WETH",
    symbol: "MWETH",
    asset: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0xbeEF346d7099865208Ff331e4f648f4154DDAa05",
    version: "v1.1",
    name: "Steakhouse Reservoir USDC",
    symbol: "bbqUSDCreservoir",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xbEeF1898443D2eB9C9C471e073f46A3928dB21dE",
    version: "v1.1",
    name: "Steakhouse High Yield Term USDC",
    symbol: "bbqUSDCterm",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xC50Abc20468b1b5597321d57002a6D4ed0AD0209",
    version: "v1.1",
    name: "BlackRock of tomorrow🤡",
    symbol: "brrrUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xD138BBE603e5cfB872cf636EF929F62dC9B137a5",
    version: "v1.1",
    name: "Cap USDC",
    symbol: "CapUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xDfbfc1A08EED81A3Da75C5079fa19EFF476a8b6f",
    version: "v1.1",
    name: "Cap USDC",
    symbol: "Cap USDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x13AA4f80AD5F06cE4f1A3a3cA58C37059F0EE4c5",
    version: "v1.1",
    name: "Stake DAO USDC v1",
    symbol: "sdUSDCv1",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x3bc4697F484F48f219B3f1Fdd2AD39cb3e986923",
    version: "v1.1",
    name: "Pocky's High Yield USDC",
    symbol: "PHYUSDCETH",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x09C4C7B1D2e9Aa7506db8B76f1dBbD61c08c114b",
    version: "v1.1",
    name: "Everstone",
    symbol: "EVST",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x0B2d98BBF3E38Df1D1B7Be7343732E32e8B1F818",
    version: "v1.1",
    name: "Cap Ecosystem USDC",
    symbol: "capUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x6701957aaA39e9352a42729Cc65436a4C945cB90",
    version: "v1.1",
    name: "AlphaPing PT Frontier",
    symbol: "AlphaPingPtFrontierUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xF9B85b19F6885511165505299648E6d052E8D4C8",
    version: "v1.1",
    name: "AlphaPing USDC Core",
    symbol: "AlphaPingCore",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x874E7Fb1aBb4c27a7BbEeeFA39E888b63181939C",
    version: "v1.1",
    name: "AlphaPing USDC Prime",
    symbol: "AlphaPingPrime",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x08A7CC3c379fe36380d3F3e4EDea3FD9b07e36D4",
    version: "v1.1",
    name: "Easy USDT",
    symbol: "ezUSD",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0x4d135cC7623D07b0ccF8931c1fAb5D67a40b0F46",
    version: "v1.1",
    name: "3Jane Vault USDC",
    symbol: "3JUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x66320aFF501D091D0929E7208977a0a94b823B43",
    version: "v1.1",
    name: "Hyperithm cbBTC Apex",
    symbol: "hypercbBTCa",
    asset: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0xA1FF9C28Ebc160c1Dcde4b9aA9551f617880c6fb",
    version: "v1.1",
    name: "Re Ecosystem USDC",
    symbol: "REUSDCVAULT",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x8b96Ed36DD3393FB4a8Bfe36b91b40AA5a4f7235",
    version: "v1.1",
    name: "PAO JPYC",
    symbol: "pJPYC",
    asset: {
      address: "0xE7C3D8C9a439feDe00D2600032D5dB0Be71C3c29",
      symbol: "JPYC",
    },
  },
  {
    id: "0xC71eF24cBE7fC859bD0C1F34eae087aCC7aAE633",
    version: "v1.1",
    name: "PAO USDC",
    symbol: "pUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x440aee600E9661FA76fB47ef74c4b8F711F52924",
    version: "v1.1",
    name: "Lamplight RWA",
    symbol: "LampRWA",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x25D385fCab771e36a826BBFB47e2Ddaa2f19D449",
    version: "v1.1",
    name: "Simple USDS",
    symbol: "SIMPLE",
    asset: {
      address: "0xdC035D45d973E3EC169d2276DDab16f1e407384F",
      symbol: "USDS",
    },
  },
  {
    id: "0xA4790AA534bf8D26EfB8DF6CB446caeECE782f73",
    version: "v1.1",
    name: "Kedao USDC Vault",
    symbol: "KdUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x7993A99d5227F764A710C0De5317332Cc28C6636",
    version: "v1.1",
    name: "Kedao USDT Vault",
    symbol: "KdUSDT",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0xb88bCE156594F066278434f2Bb94e129A3211C1F",
    version: "v1.1",
    name: "Axtior USDC Lighter LP",
    symbol: "axLLP",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xb90291c9627CF5A6B0AE203e8F93EC83F54B3c38",
    version: "v1.1",
    name: "Curate Myself",
    symbol: "CM",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0x6Ddc39fDa3EA91824bb66841b95ab7aED3a5b883",
    version: "v1.1",
    name: "Node Ag USDT",
    symbol: "naUSDT",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0xFDe11264001397547e8457735bDdBcb62A73F33d",
    version: "v1.1",
    name: "KEKEL",
    symbol: "KEKEL",
    asset: {
      address: "0xf7168c8AbB0ff80116413a8d95396BBdC318A3fF",
      symbol: "KEKE",
    },
  },
  {
    id: "0xb5a4d705bb345D8C5753878AAFC6969547AFC061",
    version: "v1.1",
    name: "Hackarrot USDC prime",
    symbol: "HckUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x7193794ec82f527Efb618Ac50C078D348eCBA4b6",
    version: "v1.1",
    name: "Etherealm USDC",
    symbol: "erUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xF685241626B66b8aACab5a6B1925B1AcDB095871",
    version: "v1.1",
    name: "Hackarrot USDT prime",
    symbol: "HckUSDT",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0xb1A90da78f33A54FC7B4BEDad5880221d263456A",
    version: "v1.1",
    name: "SenTest1",
    symbol: "senPYUSD",
    asset: {
      address: "0x6c3ea9036406852006290770BEdFcAbA0e23A0e8",
      symbol: "PYUSD",
    },
  },
  {
    id: "0x711a68a82dd80cB0435b281aF76B0B80804eFab9",
    version: "v1.1",
    name: "August USDC",
    symbol: "augustUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x9B7cca326004967f9D2B7cF5F2328d82cF65b302",
    version: "v1.1",
    name: "August AUSD",
    symbol: "augustAUSD",
    asset: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
  },
  {
    id: "0xB78fc16378A2955f11Dd380511Fd13C43CBac9ba",
    version: "v1.1",
    name: "Brrrstr USDC v1",
    symbol: "brrrUSDCv1",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x480be0C8e7f480A94d5B7Cd0e9A21E8EDDf4A91b",
    version: "v1.1",
    name: "AUSDt",
    symbol: "AUSDt",
    asset: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
  },
  {
    id: "0x29F2Cbc1e6F3250e008f91b3FFA5ffa7C460a0Fc",
    version: "v1.1",
    name: "inf-farm-mf-one",
    symbol: "inf-usdcmfone",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xc1D460067923C6F0d171a6E08E579f9Ceae3D797",
    version: "v1.1",
    name: "Kedao PYUSD Vault",
    symbol: "KdPYUSD",
    asset: {
      address: "0x6c3ea9036406852006290770BEdFcAbA0e23A0e8",
      symbol: "PYUSD",
    },
  },
  {
    id: "0x29B5D891f1E9390074271BE40670157081e614a3",
    version: "v1.1",
    name: "PINOUILLEGDX",
    symbol: "PGDX",
    asset: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
  },
  {
    id: "0x5B8b9FA8e4145eE06025F642cAdB1B47e5F39F04",
    version: "v1.1",
    name: "OUSD Vault V1",
    symbol: "OUSD-V1",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xe272BDd255d0256DDD04DA9AC4BADa04D9f16399",
    version: "v1.1",
    name: "V1 Owner Test - SS",
    symbol: "OTSS1",
    asset: {
      address: "0x4C1746A800D224393fE2470C70A35717eD4eA5F1",
      symbol: "PLUME",
    },
  },
  {
    id: "0x36716540fcAB3eE593651Ea4A00A48c85D6Fd74C",
    version: "v1.1",
    name: "Sentora PYUSD",
    symbol: "senPYUSD",
    asset: {
      address: "0x6c3ea9036406852006290770BEdFcAbA0e23A0e8",
      symbol: "PYUSD",
    },
  },
  {
    id: "0x093223c1FfE8e796D0643C01f8FBA62a3aBF6c00",
    version: "v1.1",
    name: "Sentora PYUSD",
    symbol: "senPYUSD",
    asset: {
      address: "0x6c3ea9036406852006290770BEdFcAbA0e23A0e8",
      symbol: "PYUSD",
    },
  },
  {
    id: "0x4f2F15FbED585E09F17BdA9Ec873e614a569E636",
    version: "v1.1",
    name: "SenTest3",
    symbol: "senPYUSD",
    asset: {
      address: "0x6c3ea9036406852006290770BEdFcAbA0e23A0e8",
      symbol: "PYUSD",
    },
  },
  {
    id: "0xBEeff2b772fa2F443cbd1Dd6D33b0C4bebF4aeb7",
    version: "v1.1",
    name: "Steakhouse High Yield AUSD",
    symbol: "bbqAUSD",
    asset: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
  },
  {
    id: "0x761F0E9A916FB3CD9b2BDbe9ade07D6Fe730c84b",
    version: "v1.1",
    name: "Sense cbBTC Liquid",
    symbol: "sen-cbBTC",
    asset: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0xDaBD12c08D568731af203288eb46Faf6C726aB07",
    version: "v1.1",
    name: "Sense tBTC Liquid",
    symbol: "sen-tBTC",
    asset: {
      address: "0x18084fbA666a33d37592fA2633fD49a74DD93a88",
      symbol: "tBTC",
    },
  },
  {
    id: "0x19b3cD7032B8C062E8d44EaCad661a0970DD8c55",
    version: "v1.1",
    name: "Sentora PYUSD",
    symbol: "senPYUSD",
    asset: {
      address: "0x6c3ea9036406852006290770BEdFcAbA0e23A0e8",
      symbol: "PYUSD",
    },
  },
  {
    id: "0x59C878Ebe28D5ef2Ce230eED29422Cc7a2bf9953",
    version: "v1.1",
    name: "ArbCap Metamorpho USDT",
    symbol: "arbcapmmUSDT",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0x8FA31cA7c72e5E3939ef64D55BBE4d526dfc76C9",
    version: "v1.1",
    name: "Arb Capital USDT Blue",
    symbol: "blueUSDT",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0xB3f4D94A209045Ef35661e657Db9ADAc584141f1",
    version: "v1.1",
    name: "Api3 Core USDC",
    symbol: "Api3CoreUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x794705195807451207df19A387A1fda12914140e",
    version: "v1.1",
    name: "Sense MUSD",
    symbol: "sen-MUSD",
    asset: {
      address: "0xdD468A1DDc392dcdbEf6db6e34E89AA338F9F186",
      symbol: "MUSD",
    },
  },
  {
    id: "0x23B1BAAE491471deF5Be350e63282Fa687874924",
    version: "v1.1",
    name: "Sense USDT",
    symbol: "sen-USDT",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0xBC0B65E3c2f78320c2D72b1A2D6ef85CdD9e702F",
    version: "v1.1",
    name: "Pocky's High Yield EURC",
    symbol: "PYHYEURC",
    asset: {
      address: "0x1aBaEA1f7C830bD89Acc67eC4af516284b1bC33c",
      symbol: "EURC",
    },
  },
  {
    id: "0x62efA7CAcC11CAA959A8f956EC4F683302397e5c",
    version: "v1.1",
    name: "YieldNest RWA",
    symbol: "ynUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x6D4Ff9d68101341BD9D4A510a90E2Ff8BF7de950",
    version: "v1.1",
    name: "JT Vault1",
    symbol: "Skale",
    asset: {
      address: "0x00c83aeCC790e8a4453e5dD3B0B4b3680501a7A7",
      symbol: "SKL",
    },
  },
  {
    id: "0x62067831C193810F3b044Cc42249632b5d08Bc6b",
    version: "v1.1",
    name: "Kabu USDC",
    symbol: "KabuUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x8B3b3a5657f1B5169712c9e06437fe80645637C7",
    version: "v1.1",
    name: "deprecated2",
    symbol: "deprecated2",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x78077F8Ba6a9bB0909878De65195ccAc4294Ca21",
    version: "v1.1",
    name: "deprecated",
    symbol: "deprecated",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xc88eFFD6e74D55c78290892809955463468E982A",
    version: "v1.1",
    name: "kpk ETH Yield",
    symbol: "kpk_ETH_Yield",
    asset: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0x9178eBE0691593184c1D785a864B62a326cc3509",
    version: "v1.1",
    name: "kpk USDC Yield",
    symbol: "kpk_USDC_Yield",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x19fa187F0A5e653C9C1b98Ba380e3B3399B114F7",
    version: "v1.1",
    name: "jt v2",
    symbol: "JTT",
    asset: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0x3c754561CD0B4df9513b7B6bC200963620c7b77e",
    version: "v1.1",
    name: "Lamplight High Yield",
    symbol: "LampHY",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x38A4E979425D93DcC20af37bE22966D1bff9ecD0",
    version: "v1.1",
    name: "Node Ag EURC",
    symbol: "naEURC",
    asset: {
      address: "0x1aBaEA1f7C830bD89Acc67eC4af516284b1bC33c",
      symbol: "EURC",
    },
  },
  {
    id: "0x9A36c86678CAdA1aD9646B99976206Fc0410d9E1",
    version: "v1.1",
    name: "Hadjime EURC Prime",
    symbol: "EURC",
    asset: {
      address: "0x1aBaEA1f7C830bD89Acc67eC4af516284b1bC33c",
      symbol: "EURC",
    },
  },
  {
    id: "0xdB93466fA32b9f898881c225bAB921C1035c6d26",
    version: "v1.1",
    name: "EURC-ARX",
    symbol: "EURX",
    asset: {
      address: "0x1aBaEA1f7C830bD89Acc67eC4af516284b1bC33c",
      symbol: "EURC",
    },
  },
  {
    id: "0xEF0aDE42a4885604AfF94033F8F8c474BAeC5C4E",
    version: "v1.1",
    name: "better-EURC",
    symbol: "bEURC",
    asset: {
      address: "0x1aBaEA1f7C830bD89Acc67eC4af516284b1bC33c",
      symbol: "EURC",
    },
  },
  {
    id: "0x959de0785A58a587a77FcFc079f09a131a27187B",
    version: "v1.1",
    name: "liquid.EURC",
    symbol: "lEUR",
    asset: {
      address: "0x1aBaEA1f7C830bD89Acc67eC4af516284b1bC33c",
      symbol: "EURC",
    },
  },
  {
    id: "0x69a61A331d56a6fE6ea1226dE89744982Ffca4C4",
    version: "v1.1",
    name: "Pocky's High Yield WETH",
    symbol: "PYHYWETH",
    asset: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0xC3be62EBD4dbb46901F241d5144Cde38a7f8a954",
    version: "v1.1",
    name: "wth",
    symbol: "Wth",
    asset: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0xbbC901782e2409751ac7bB7C6a778080570600E0",
    version: "v1.1",
    name: "Baguette USDS Yield",
    symbol: "BUS",
    asset: {
      address: "0xdC035D45d973E3EC169d2276DDab16f1e407384F",
      symbol: "USDS",
    },
  },
  {
    id: "0x5541693d0090f2C9b386D2144b7138933265f209",
    version: "v1.1",
    name: "Etherealm USDT",
    symbol: "erUSDT",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0x0C1B9c8559A9706ffD5324B3AaF33D0f7b7177e4",
    version: "v1.1",
    name: "Exclusive Sentora PYUSD",
    symbol: "ethenasenPYUSD",
    asset: {
      address: "0x6c3ea9036406852006290770BEdFcAbA0e23A0e8",
      symbol: "PYUSD",
    },
  },
  {
    id: "0x2C793f5cB25B35A99648783c01E6cCCC200D2096",
    version: "v1.1",
    name: "Sentora PYUSD Core",
    symbol: "senPYUSDcore",
    asset: {
      address: "0x6c3ea9036406852006290770BEdFcAbA0e23A0e8",
      symbol: "PYUSD",
    },
  },
  {
    id: "0x3af9477CdB6E291150Dc9E19724b9097C102c188",
    version: "v1.1",
    name: "TelosC AUSD Equities & Commodities",
    symbol: "eqAUSD",
    asset: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
  },
  {
    id: "0x3Dfe70B05657949A5dB340754aD664810ac63b21",
    version: "v1.1",
    name: "WETH ARM Vault",
    symbol: "WETH-ARM",
    asset: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0xFB219e20e7Ad26345FD3474EBA6C9250482971Cf",
    version: "v1.1",
    name: "Philidor USDC Prime",
    symbol: "phiUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xA726EcC858652a6917a8ee5Ca7e1D2963191A43f",
    version: "v1.1",
    name: "Philidor EURC Prime",
    symbol: "phiEURC",
    asset: {
      address: "0x1aBaEA1f7C830bD89Acc67eC4af516284b1bC33c",
      symbol: "EURC",
    },
  },
  {
    id: "0xbeEffff0629438aD198c47F80d66FA4Be5C0caF6",
    version: "v1.1",
    name: "Grove x Steakhouse High Yield AUSD",
    symbol: "grove-bbqAUSD",
    asset: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
  },
  {
    id: "0x9f5576CCBdF64e84f6e8c546DEb65E706966E26d",
    version: "v1.1",
    name: "Etherealm ETH",
    symbol: "erETH",
    asset: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0x62578B2C9676E951c476d77406f8914e5446b661",
    version: "v1.1",
    name: "Hybrid Tandem Propulsion USDC",
    symbol: "HTP USDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x00B2681EC02650B16A2E4F6D34ea7d8866ed8eA4",
    version: "v1.1",
    name: "cakeUSDC",
    symbol: "ckUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xEB4388bb10cB60388Ea8b6927F39945203C1FED3",
    version: "v1.1",
    name: "wNXM-stNXM Vault",
    symbol: "ib-wNXM",
    asset: {
      address: "0x0d438F3b5175Bebc262bF23753C1E53d03432bDE",
      symbol: "wNXM",
    },
  },
  {
    id: "0xF9A61C85Bfe6cbc586c8704AD7cdEa7695e81AeD",
    version: "v1.1",
    name: "TestPrimeUSDC",
    symbol: "TPUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xBeeFBedc6fF26A7C4234434e2944dBDb6D4FbF37",
    version: "v1.1",
    name: "Steakhouse Prime EURC",
    symbol: "steakEURC",
    asset: {
      address: "0x1aBaEA1f7C830bD89Acc67eC4af516284b1bC33c",
      symbol: "EURC",
    },
  },
  {
    id: "0x633ceC920306495ee526cAD96464087DF5204889",
    version: "v1.1",
    name: "ACRDX USDC Vault V1",
    symbol: "acrdxUSDC-V1",
    asset: {
      address: "0xB6A9c3375b3a57dA78F7C467Bd7B91cb8665A61e",
      symbol: "USDC",
    },
  },
  {
    id: "0x4ff0DE50900E3d999ab2c6F957918773992aa35a",
    version: "v1.1",
    name: "LaCroixVaults",
    symbol: "LCUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x23D4D3A21741F13c3DA4B7922bAf678208A18dEc",
    version: "v1.1",
    name: "Reserve Muer",
    symbol: "MUER",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xB352fd86B73D72bc16817aa101dfB1C03C95Bd24",
    version: "v1.1",
    name: "BlackWing USDC Core",
    symbol: "BWC(USDC)",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xF2315Eb6B19019B7c0AeD91d562E2f6fAe26DB36",
    version: "v1.1",
    name: "LMFAO<b>LOL</b>",
    symbol: "LMFAO<b>LOL</b>",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x6Fd59570172411Fc810258FeF8A12cE1b7EF60d7",
    version: "v1.1",
    name: "Mprinter USDC Yield Vault",
    symbol: "mUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x466e855072d87284314200DEDB9bfDa7145859bc",
    version: "v1.1",
    name: "usdc staging",
    symbol: "gtstgusdc",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x061fd7757bc028551fe001b8844d0B312838F08d",
    version: "v1.1",
    name: "DRF USDT Vault",
    symbol: "drfUSDT",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0xB4c1029E29F09093BE7BFa61C5D1D2d0AdDE9abb",
    version: "v1.1",
    name: "0x5003121c11daf46d7ce8c1ebc1c51cbc3a8002a9",
    symbol: "0x5003121c11daf46d7ce8c1ebc1c51cbc3a8002a9",
    asset: {
      address: "0x5003121c11DAF46D7Ce8c1eBc1c51cbC3A8002A9",
      symbol: "KEKEL",
    },
  },
  {
    id: "0x0551DE0FF64E0ef199CA5714700F1c648E9Fca88",
    version: "v1.1",
    name: "Philidor wstETH",
    symbol: "phiwstETH",
    asset: {
      address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
      symbol: "wstETH",
    },
  },
  {
    id: "0xB2376cC88EA47C80fFC3De60dAe8F2F48BC872a3",
    version: "v1.1",
    name: "Stake DAO frxUSD v1",
    symbol: "sdFRXUSDv1",
    asset: {
      address: "0xCAcd6fd266aF91b8AeD52aCCc382b4e165586E29",
      symbol: "frxUSD",
    },
  },
  {
    id: "0xf4670D639898ebeb0c8D401E1df423e37b922A93",
    version: "v1.1",
    name: "Sovereign Treasury Yield Vault",
    symbol: "styvUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x1518652736c4eFD9DFA46D68aE83b69C8af802F0",
    version: "v1.1",
    name: "xIxGxNxOxRxEx",
    symbol: "xIxGxNxOxRxEx",
    asset: {
      address: "0x91d14789071e5E195FFC9F745348736677De3292",
      symbol: "dCOMP",
    },
  },
  {
    id: "0xE6F0ce5394B3D15b4aB1216D84F544b8f38E4D69",
    version: "v1.1",
    name: "Api3 dCOMP USDC",
    symbol: "Api3-dCOMP-USDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x71cb2F8038B2C5D65ddc740B2F3268890CD2A89C",
    version: "v1.1",
    name: "Sentora RLUSD",
    symbol: "senRLUSD",
    asset: {
      address: "0x8292Bb45bf1Ee4d140127049757C2E0fF06317eD",
      symbol: "RLUSD",
    },
  },
  {
    id: "0x52aCfdF7Cee53d6Bf23aE20d78e3175564C55ef4",
    version: "v1.1",
    name: "test",
    symbol: "dusdc",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xdaD4e51d64c3B65A9d27aD9F3185B09449712065",
    version: "v1.1",
    name: "kpk USDT Prime",
    symbol: "kpk_USDT_Prime",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0x311D1F9F998DCb5Ad794a2584d5DEB603b970d9b",
    version: "v1.1",
    name: "Cozy USDC",
    symbol: "cozyUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x81AE586dE7876a4C06163bEe0598AD2471E67322",
    version: "v1.1",
    name: "Julian Capital Yield USDC",
    symbol: "JULIANUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xbEEF8833f9Ff8e9D950Df3CEFb78DA88931C0450",
    version: "v1.1",
    name: "Steakhouse Resolv USR",
    symbol: "bbqUSRresolv",
    asset: {
      address: "0x66a1E37c9b0eAddca17d3662D6c05F4DECf3e110",
      symbol: "USR",
    },
  },
  {
    id: "0x35dD24fA0cad1cAE633616436cECEDC99a19Ae9f",
    version: "v1.1",
    name: "Test USDT",
    symbol: "testUSDT",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0x87cb57D154ED695c4652ed755D49D7C99708b943",
    version: "v1.1",
    name: "alpha8USDC",
    symbol: "alpha8USDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x310533D92D93c0dD7608D9A7B13017DA88a4828C",
    version: "v1.1",
    name: "fwUSDC Vault",
    symbol: "fwmUSDC",
    asset: {
      address: "0x0492560FA7Cfd6A85E50D8bE3F77318994F8f429",
      symbol: "fwUSDC",
    },
  },
  {
    id: "0x719b4b1F4c512F9a519F13D106EFA0B66bBACAD5",
    version: "v1.1",
    name: "fwUSDT Vault",
    symbol: "fwmUSDT",
    asset: {
      address: "0xef87f4608e601E8564800265AeE1c1FfaDF73283",
      symbol: "fwUSDT",
    },
  },
  {
    id: "0x4fddD263891e6EdC5A56ed306B64FEAB2a4af74d",
    version: "v1.1",
    name: "fwDAI Vault",
    symbol: "fwmDAI",
    asset: {
      address: "0x8A6fe57C08C84e0f4eE97aAe68a62e820a37d259",
      symbol: "fwDAI",
    },
  },
  {
    id: "0x10Becd2559671b36E9D43C8cE6c0B86E16C59420",
    version: "v1.1",
    name: '"Parity Core USDC"',
    symbol: '"pcUSDC"',
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xB7fC92B6ddc6612623812106e5B7532D3a48420B",
    version: "v1.1",
    name: "Parity Core ETH",
    symbol: "pcETH",
    asset: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0x2bB005127069A0F0325Fb7370967E8A2b64FB77E",
    version: "v1.1",
    name: "Yearn WBTC",
    symbol: "ymv-WBTC",
    asset: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
  },
  {
    id: "0x0963232eB842BAF53E8e517691f81745C1F228a0",
    version: "v1.1",
    name: "Yearn USDT",
    symbol: "ymv-USDT",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0xB632d9b2Cf8d022339C21d4486Aba3184fBfC287",
    version: "v1.1",
    name: "Zircuit Finance USDT on Etheruem",
    symbol: "zf-meUSDT",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0xf2e50b4b4254Db03683d2773bC784c546F0a25d9",
    version: "v1.1",
    name: "Zircuit Finance USDC on Etheruem",
    symbol: "zf-meUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xF1CfaA17d21B399F122B8615FAc12F95766eBed3",
    version: "v1.1",
    name: "Parity High Yield USDC",
    symbol: "pcHYUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x90B482cA9769807569998B20e062e024B1A0A39d",
    version: "v2",
    name: "Test Vault",
    symbol: "tstv",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xc44a34150DFDC051cFa173Da9608BbD12F2fd157",
    version: "v2",
    name: "Peaty USDC",
    symbol: "ptUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xdcdCEa96147672Fe3B56dCb1AA5608332B67Ff84",
    version: "v2",
    name: "Peaty USDC",
    symbol: "ptUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x612C91147c7b162765b4343994a05ab65181cD5e",
    version: "v2",
    name: "Test790",
    symbol: "testtt",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x458A135f2359c25b4ff5daDCDE29765758cf490E",
    version: "v2",
    name: "Test795",
    symbol: "testtt",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xef236dA50f27EfB24EDdE34cC0D6504018F26DC7",
    version: "v2",
    name: "Test799",
    symbol: "testtt",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xdA1CE5b0379883c3d1D4Ebb85b61979844c41cd4",
    version: "v2",
    name: "Test795",
    symbol: "testtt",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xc14488a2188Cc7cCF1C40d5e56D43F4211c5509C",
    version: "v2",
    name: "Test900",
    symbol: "test9",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xCE341182ad323b9CB5aD45A60859dbc356dC3dDd",
    version: "v2",
    name: "zzzz",
    symbol: "zzzz",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xbB5ad5d522684de9dD3f545fa6D6ac5BBCA4710E",
    version: "v2",
    name: "Alpha WETH Core V2",
    symbol: "alphaWETHCoreV2",
    asset: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0xE31027e24b6770d3Ac48d5418176426787771321",
    version: "v2",
    name: "TestG",
    symbol: "testG",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x9EeAD226dd9fBa1415B7495A0844035ff1Fc2B93",
    version: "v2",
    name: "TestG",
    symbol: "testG",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xeBC63D17b552323f6ab0709d773FeB9a7401effC",
    version: "v2",
    name: "TestG",
    symbol: "testG",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xbF27BfF704cE0a0f1b287fF6429B9375D8446092",
    version: "v2",
    name: "TestG",
    symbol: "testG",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x29839aa25edC1c900C704702559AD84D036A8F8f",
    version: "v2",
    name: "TestG",
    symbol: "testG",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x5431ca0179365C39C635b22dF562bB1796E3ac7D",
    version: "v2",
    name: "TestG",
    symbol: "testG",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xa830F31eee1b93D9339C33A81175286De8748429",
    version: "v2",
    name: "hercules",
    symbol: "hcp",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x870bFeb87Fb68EFC7A4DC7e82feed1a1A8d373d3",
    version: "v2",
    name: "TestG",
    symbol: "testG",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x6a0D30cC6e52ee99DCF5b1F623afdb9D3C5E4fE6",
    version: "v2",
    name: "TestG",
    symbol: "testG",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xeCD6E58C6Cf196eC4566178c76EeB175FDDC5F16",
    version: "v2",
    name: "TestG",
    symbol: "testG",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x6440be3f7a486404Fd5615753Ec79ff6f32e661f",
    version: "v2",
    name: "TestG",
    symbol: "testG",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x613EE866E4fF1EABE6C2D2434140DD8D820577E9",
    version: "v2",
    name: "M11C USDC v2",
    symbol: "m11USDCv2",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x755F2871B8424702f45bB294e9b071B32f3F5917",
    version: "v2",
    name: "Gauntlet USDC Prime",
    symbol: "gtUSDCp",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x8c106EEDAd96553e64287A5A6839c3Cc78afA3D0",
    version: "v2",
    name: "Gauntlet USDC Prime",
    symbol: "gtusdcp",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x5f342382D5F77F0f99E8f26161E689df6c7Cded3",
    version: "v2",
    name: "Gauntlet WETH Balanced",
    symbol: "gtwethb",
    asset: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0x550d857B0555e872103Ed58F124D5153AEdf1879",
    version: "v2",
    name: "WETH PRIME",
    symbol: "gtwethp",
    asset: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0x43fCd85E8D9D003D515f886891B7C742AC9f92da",
    version: "v2",
    name: "Gauntlet WETH Prime",
    symbol: "gtwethp",
    asset: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0x9a1D6bd5b8642C41F25e0958129B85f8E1176F3e",
    version: "v2",
    name: "Gauntlet USDC Frontier",
    symbol: "gtusdcf",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xd296290f78d8436c01F0553ddB42653C8D778004",
    version: "v2",
    name: "Testt",
    symbol: "Testt",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xfAF012F030f4f6bB9b43e1cC80D0574C067E18A2",
    version: "v2",
    name: "Testt",
    symbol: "Testt",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xa1F315C7C8D0088a4Ed63e83AE62674113747e1a",
    version: "v2",
    name: "Arb Capital CANA/USDT Vault",
    symbol: "ARB-CANAUSDT",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0x04422053aDDbc9bB2759b248B574e3FCA76Bc145",
    version: "v2",
    name: "Keyrock USDC",
    symbol: "kUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x74847d0D124ce5C89Ca8f4e7547AECD09E86B2E0",
    version: "v2",
    name: "Blue Chip USDC Vault (Prime)",
    symbol: "PRIME",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x69A238Ae7ebeb3c53ff3B544E48B96a2142fc284",
    version: "v2",
    name: "Clearstar USDC Core",
    symbol: "CSUSDCCORE",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x81aC09804213710C11675f68d7579e3E0F2e261c",
    version: "v2",
    name: "Syntropia USDC",
    symbol: "synUSDm",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x30cACd22F178C9E57b0b010e1f9432881aa530C4",
    version: "v2",
    name: "ByzPrime USD",
    symbol: "byzUSD",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x881260e209efAF6792fC793Ba922177B3607A64f",
    version: "v2",
    name: "testWETHv2",
    symbol: "test_WETH_v2",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x4Ef53d2cAa51C447fdFEEedee8F07FD1962C9ee6",
    version: "v2",
    name: "KPK USDC Prime",
    symbol: "KPK_USDC_Prime",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xa877D5bb0274dcCbA8556154A30E1Ca4021a275f",
    version: "v2",
    name: "KPK EURC Yield",
    symbol: "KPK_EURC_Yield",
    asset: {
      address: "0x1aBaEA1f7C830bD89Acc67eC4af516284b1bC33c",
      symbol: "EURC",
    },
  },
  {
    id: "0xbB3a3905e326d0e0EA37Da19eDd5e4d9C1A50e6A",
    version: "v2",
    name: "discarded ETH",
    symbol: "discarded",
    asset: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0xE6BEAEe51D3EE6Fc88A324088053c4a732bBa3E9",
    version: "v2",
    name: "1337 USDC",
    symbol: "1337USDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x5181cD56C2C71d20094d23d43F4D6362834643AE",
    version: "v2",
    name: "Re7 WETH",
    symbol: "Re7WETH",
    asset: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0xe8475ab59ebC297Df7a2e8D7793AB88Fc2DF7B4b",
    version: "v2",
    name: "Bachata USDC",
    symbol: "bachata_USDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x787FC686879EaCE7Ad94A63fcEcd520fdeAf7AF9",
    version: "v2",
    name: "f(x) Protocol Re7 USDC",
    symbol: "fxRe7USDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x1CE2354074C717a266aDADCD5e34104f233Da446",
    version: "v2",
    name: "Re7 USDT",
    symbol: "Re7USDT",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0x66018886048A969d5e3EDB0Aba6292bA6f06aB07",
    version: "v2",
    name: "Re7 USDC Core",
    symbol: "Re7USDCc",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x04447273Ee808702a4855403af0acE8E7c042122",
    version: "v2",
    name: "Re7 USDC Prime",
    symbol: "Re7USDCp",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x093272C07700d3cA5301C3Bf9B3A392624179E2F",
    version: "v2",
    name: "Hyperithm USDC Apex",
    symbol: "hyperUSDCa",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xbeef0C40fbfC72d8dc24acAdE2ec2B5a6A2C7Fc4",
    version: "v2",
    name: "Steakhouse Prime Instant",
    symbol: "steakUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xbeeff48d072197e2F8F8F9bd49Af900EBc6EeA4E",
    version: "v2",
    name: "Steakhouse High Yield Instant",
    symbol: "bbqUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xbeeff2C5bF38f90e3482a8b19F12E5a6D2FCa757",
    version: "v2",
    name: "Steakhouse High Yield USDC",
    symbol: "bbqUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xbeef088055857739C12CD3765F20b7679Def0f51",
    version: "v2",
    name: "Steakhouse Prime USDC",
    symbol: "steakUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xE1D8baE89a4B9633F536D2AeBE057A211381B054",
    version: "v2",
    name: "Kahuna Stillwater USDC",
    symbol: "kc-stillwater-usdc",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x21A303957549682f8b0C340aad4ae693f91dE8d7",
    version: "v2",
    name: "Lamplight RWA",
    symbol: "LampRWA",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x5E5b30c5fD07da26d1e515dfEDb1D37C93417652",
    version: "v2",
    name: "SingularV USDC",
    symbol: "svUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xbeeff5d996F649eB9b35514610A5F660Da3d0684",
    version: "v2",
    name: "Steakhouse High Yield Term",
    symbol: "bbqUSDCterm",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xe08afcdb51872BBD51241f49e84F29D910cedFB4",
    version: "v2",
    name: "discarded 2",
    symbol: "discarded",
    asset: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0xBb50A5341368751024ddf33385BA8cf61fE65FF9",
    version: "v2",
    name: "KPK ETH Prime",
    symbol: "KPK_ETH_Prime",
    asset: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0x8EDCC305E633d29BFB383872e79401c506cE9E6f",
    version: "v2",
    name: "Stake DAO USDC v2",
    symbol: "sdUSDCv2",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xAC301bf985551fa1bFBED418E39F0e62eA04fF00",
    version: "v2",
    name: "Curve StakeDAO Boosted",
    symbol: "curveusdc",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xe28b0b99Ac2bD1123DdaB0398D6Ef3B68b6994f6",
    version: "v2",
    name: "Easy USDT",
    symbol: "ezUSD",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0xcE64BB7C271387c9831f67C54ec0611Caf453359",
    version: "v2",
    name: "Ramp Network x Steakhouse",
    symbol: "rampnetwork-steakhouseUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xbEEF00B21d79c9cfd857b3944743D11F8426e184",
    version: "v2",
    name: "Ramp Network x Steakhouse",
    symbol: "rampnetwork-steakhouseUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x91292Ae9e3Fd9d2eE9b83349843947cF02350B73",
    version: "v2",
    name: "Ready x Steakhouse High Yield USDC",
    symbol: "ready-bbqUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x38AaB7cED2e026a88c6830AaE3D87466DdB09C3e",
    version: "v2",
    name: "PAO JPYC Vault",
    symbol: "pJPYC",
    asset: {
      address: "0xE7C3D8C9a439feDe00D2600032D5dB0Be71C3c29",
      symbol: "JPYC",
    },
  },
  {
    id: "0xA7A78E8e98c734f87A3B07D8DB627C67001ABD02",
    version: "v2",
    name: "gtsy",
    symbol: "gtsy",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x7aD470Ba664cfc15998dB4d458699A4E76f2d0B6",
    version: "v2",
    name: "Gauntlet USDC Prime",
    symbol: "SGUCP",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xE08145eb0132a219aad1B78a85baD8666a97CB94",
    version: "v2",
    name: "Gauntlet USDC Core",
    symbol: "SGUCC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x43FB24Ad02a101Acc128eB2AD76a240245C2aD47",
    version: "v2",
    name: "Gauntlet USDT Prime",
    symbol: "SGUTP",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0x6aB8dd6124E5F5789B8b5074C5760b9917A2DFc6",
    version: "v2",
    name: "Gauntlet USDT Core",
    symbol: "SGUTC",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0x517cd9689881F04942A333640DAff318732683B4",
    version: "v2",
    name: "Axtior USDC Lighter LP",
    symbol: "axLLP",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x6f86e4224aB8C1c3E001eBb397D7Eb69E82Ac0A0",
    version: "v2",
    name: "Curate Myself",
    symbol: "CM",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0xB885F6d448dA7E2C642Ec31190B629E40E87B069",
    version: "v2",
    name: "Yearn OG USDC",
    symbol: "yOG-USDC-V2",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xCdbe4A5B5bAd2BC04492052Df2F881B5727d034d",
    version: "v2",
    name: "Hyperithm cbBTC Apex",
    symbol: "hypercbBTCa",
    asset: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0x7C51228C60FE580249F0bD99F61740c0594B23b3",
    version: "v2",
    name: "ByzPrime USD (insured)",
    symbol: "byzUSDi",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x5cf02f71D2c5e928F9B406db4BD8680a07e3eBD1",
    version: "v2",
    name: "CaliberTest",
    symbol: "CAL",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x62efCdAf376AC83c80e4BB4a74CBaC96936b6345",
    version: "v2",
    name: "Optimex USDC",
    symbol: "OptimexUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xf3557AD5E984211ac8A0874A670344f2C3376471",
    version: "v2",
    name: "Gauntlet USDT Prime",
    symbol: "gtusdtp",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0xE571B648569619566CF6ce1060C97B621CB635D3",
    version: "v2",
    name: "Gauntlet USDT Frontier",
    symbol: "gtusdtf",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0x28A9B2e74D9e50E89d4efE6B5461A01C43113614",
    version: "v2",
    name: "Optimex USDC",
    symbol: "OptimexUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xbeef00B5d83C1188F07A5184230a805639c39f04",
    version: "v2",
    name: "Steakhouse Prime Instant",
    symbol: "steakPYUSD",
    asset: {
      address: "0x6c3ea9036406852006290770BEdFcAbA0e23A0e8",
      symbol: "PYUSD",
    },
  },
  {
    id: "0xbeef0046fcab1dE47E41fB75BB3dC4Dfc94108E3",
    version: "v2",
    name: "Steakhouse Prime ETH",
    symbol: "steakETH",
    asset: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0xbeef003C68896c7D2c3c60d363e8d71a49Ab2bf9",
    version: "v2",
    name: "Steakhouse Prime USDT",
    symbol: "steakUSDT",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0xee0fc3bEe614Dda3e8E7D29541F64EEA71a00b22",
    version: "v2",
    name: "test vault",
    symbol: "TESTVAULT",
    asset: {
      address: "0x99CD4Ec3f88A45940936F469E4bB72A2A701EEB9",
      symbol: "stUSDS",
    },
  },
  {
    id: "0xfed0070Bf03F2f0eCc1074D91058F786df262536",
    version: "v2",
    name: "Hackarrot USDC prime",
    symbol: "HckUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x047fec0E3e7f018dDCC834dcF4fe633DA3A26071",
    version: "v2",
    name: "June Test",
    symbol: "juneTEST",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0xD1E9242e075Db4bdd3f3c721D7d5fd4180A94A7e",
    version: "v2",
    name: "Re Ecosystem Vault",
    symbol: "REECOUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x633bdC298c7F663A9000257DC495C30E910351A4",
    version: "v2",
    name: "Test WETH Vault",
    symbol: "tWETH",
    asset: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0x7ceB0f01Cb7187a2EBED5661eCC4d5701d8F2350",
    version: "v2",
    name: "August USDC V2",
    symbol: "augustUSDCv2",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x29B70A270723731bBCBE94E1F1A53977677AB604",
    version: "v2",
    name: "Meta3X",
    symbol: "m3xUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xA01B3A71487753F28d8f5fDF166B7B467C765D09",
    version: "v2",
    name: "Brrrstr USDC",
    symbol: "brrrUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x3E776B961B290FcE55A5E1b6f5484Aba8922550A",
    version: "v2",
    name: "Ready x Steakhouse USDC",
    symbol: "ready-bbqUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xbeeFf0956ACb02E6F203e83D6eaE357A1d7d116C",
    version: "v2",
    name: "Ready x Steakhouse USDC",
    symbol: "ready-bbqUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xbe518068EB6135117207256F8C9aFf81B4382DB1",
    version: "v2",
    name: "Yearn OG WETH V2",
    symbol: "yOG-WETH-V2",
    asset: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0xbeeff07d991C04CD640DE9F15C08ba59c4FEDEb7",
    version: "v2",
    name: "Steakhouse High Yield USDT",
    symbol: "bbqUSDT",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0x9A6CB6CaffE68b91C9A36E2657489Da3c2b1E116",
    version: "v2",
    name: "Test WETH Vault",
    symbol: "tWETH",
    asset: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0xE7F8Fb5CccC3e70B922FE696ae6B550557f88Da5",
    version: "v2",
    name: "August AUSD V2",
    symbol: "augustAUSDv2",
    asset: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
  },
  {
    id: "0x0229dB3921dE71CFa43Cfe9fb6A87b403647A9ae",
    version: "v2",
    name: "Hyperithm USDC Core",
    symbol: "hyperUSDCc",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x1394841afe9cb4Eaad8d60278AF25ecbe179C5Af",
    version: "v2",
    name: "Hyperithm ETH Apex",
    symbol: "hyperETHa",
    asset: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0xCeD26785C5d1AD90A37bF6CFa5f278A50daC9E8D",
    version: "v2",
    name: "Hyperithm USDT Degen",
    symbol: "hyperUSDTd",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0x812376D6a705913F067371Ab29166E29f0360A44",
    version: "v2",
    name: "Sense cbBTC Liquid",
    symbol: "sen-cbBTC",
    asset: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0xbeef0C075Da5D01112AE5cF34d257074fB5DDB2f",
    version: "v2",
    name: "Steakhouse Prime EURCV",
    symbol: "steakEURCV",
    asset: {
      address: "0x5F7827FDeb7c20b443265Fc2F40845B715385Ff2",
      symbol: "EURCV",
    },
  },
  {
    id: "0xFb44F0aCE2D757c4368001EF6755F5C3d58f94B0",
    version: "v2",
    name: "OUSD Vault V2",
    symbol: "mOUSD-V2",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xbEeFf89ABb7815cCD5182BD1FF82C4a4F8FCb13D",
    version: "v2",
    name: "Steakhouse High Yield Instant",
    symbol: "bbqAUSD",
    asset: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
  },
  {
    id: "0xb576765fB15505433aF24FEe2c0325895C559FB2",
    version: "v2",
    name: "Paypal USD Main",
    symbol: "senPYUSDmain",
    asset: {
      address: "0x6c3ea9036406852006290770BEdFcAbA0e23A0e8",
      symbol: "PYUSD",
    },
  },
  {
    id: "0xbeef0D24920098C404c7Fc7942ee6d0f66d65D57",
    version: "v2",
    name: "Safe x Steakhouse Prime Instant",
    symbol: "safe-steakEURCV",
    asset: {
      address: "0x5F7827FDeb7c20b443265Fc2F40845B715385Ff2",
      symbol: "EURCV",
    },
  },
  {
    id: "0xFB154c729A16802c4ad1E8f7FF539a8b9f49c960",
    version: "v2",
    name: "OUSD Vault V2",
    symbol: "OUSD-V2",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xB7305D968ECD8a23a13eC01927E3f9588C7653B5",
    version: "v2",
    name: "Etherealm USDC",
    symbol: "erUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xe2221Aa07ec3266DA87763E2b1e28d07A8a4e53b",
    version: "v2",
    name: "Api3 Core USDC",
    symbol: "Api3CoreUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xBEEFFFcbA46C49A24cfBfFc19166e8f089B59300",
    version: "v2",
    name: "Steakhouse High Yield Turbo",
    symbol: "ptETHturbo",
    asset: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0xBEEFFF4716a49418D69c251cab8759bB107e57C8",
    version: "v2",
    name: "Steakhouse High Yield Turbo",
    symbol: "bbqUSDCturbo",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xd8A6511979D9C5D387c819E9F8ED9F3a5C6c5379",
    version: "v2",
    name: "Steakhouse High Yield Instant",
    symbol: "bbqPYUSD",
    asset: {
      address: "0x6c3ea9036406852006290770BEdFcAbA0e23A0e8",
      symbol: "PYUSD",
    },
  },
  {
    id: "0xBEEFFFC57A26fD8D3b693Ba025ead597DbECEBfe",
    version: "v2",
    name: "Steakhouse High Yield Term",
    symbol: "bbqUSDCterm",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xD5cCe260E7a755DDf0Fb9cdF06443d593AaeaA13",
    version: "v2",
    name: "KPK USDC Yield",
    symbol: "KPK_USDC_Yield",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x5dbf760b4fd0cDdDe0366b33aEb338b2A6d77725",
    version: "v2",
    name: "KPK ETH Yield",
    symbol: "KPK_ETH_Yield",
    asset: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0x9215f1777383d48165e6F3a842Bf0E0A89b5C667",
    version: "v2",
    name: "xIxGxNxOxRxEx",
    symbol: "xIxGxNxOxRxExAsset",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xBEEFFF506B52B3323c48aFE0Cb405A284F0f9cF2",
    version: "v2",
    name: "Steakhouse High Yield Turbo",
    symbol: "ptCBBTCturbo",
    asset: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0x54210d3f1A066413891AF9E17210E787d5C6e3f4",
    version: "v2",
    name: "Kabu USDC",
    symbol: "KabuUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xE77a01FC0DE7686a02E88bC323de66BF9fEEa2EB",
    version: "v2",
    name: "Lamplight High Yield",
    symbol: "LampHY",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xa30D20cB10c869bAf99EbeADFD79408fe7Ad8FaA",
    version: "v2",
    name: "gtsy (usdt)",
    symbol: "gusdt",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0xb1EC0Be0fe8485F0B5309bB1aA1cE7d4B100E265",
    version: "v2",
    name: "AUSDtt",
    symbol: "AUSD",
    asset: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
  },
  {
    id: "0xe05faDf242331808f504661BEA65972594869826",
    version: "v2",
    name: "3Jane Ecosystem Vault",
    symbol: "CS3JANECO",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xA1B096268D200d0ecFD57015700F6a0DA9c494e2",
    version: "v2",
    name: "YieldNest RWA",
    symbol: "ynUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xeBBaE8CfAbB0092d5B32f00EBeE0c8139d24dDcd",
    version: "v2",
    name: "Avantgarde USDC Conservative",
    symbol: "AVGUSDCcons",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xE41a5E49E0afA6C3058BA8f44D82Cb38a3B86EE9",
    version: "v2",
    name: "test",
    symbol: "TEST",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x7f5b0a5a8517d46967F408C59334ada9a11CB8c3",
    version: "v2",
    name: "test",
    symbol: "TEST",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x61D162885700174b065142bf28DB64573F06EfD5",
    version: "v2",
    name: "test",
    symbol: "TEST",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xbeef3F9595EC8a4C222AcDB2daA401C59580ac4e",
    version: "v2",
    name: "3F x Steakhouse USDC",
    symbol: "3F-steakUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xBeEf3F9495E101EBf379D16cDE98131717bdb7bf",
    version: "v2",
    name: "3F x Steakhouse USDC",
    symbol: "3F-steakUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xD003882EbAbed209d27f30C7E80077efB7F78498",
    version: "v2",
    name: "AIRG Fund",
    symbol: "AIRG",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xBeEf3FC80fd62989190085221dFBb02F2f8a3B9C",
    version: "v2",
    name: "3F x Steakhouse USDC",
    symbol: "3F-steakUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x3d719f2A8E5e9674e9e37057029f5EC65B4d7256",
    version: "v2",
    name: "Test",
    symbol: "TEST",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xBeefF08dF54897e7544aB01d0e86f013DA354111",
    version: "v2",
    name: "Grove x Steakhouse USDC",
    symbol: "grove-bbqUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x66CCc79753E58ae213614D81515A95f9610aaF1F",
    version: "v2",
    name: "AUSDttt",
    symbol: "AUSD",
    asset: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
  },
  {
    id: "0xAdAe2890377F3e51593b9Df212fbBA8Ba07FB31E",
    version: "v2",
    name: "USDC Fun",
    symbol: "FUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x79955080F90207De42A20aEB4DA43EFf2FFB2DDc",
    version: "v2",
    name: "Test",
    symbol: "TEST",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xAE57b2874673C7E0f5462B598220775017094E8f",
    version: "v2",
    name: "sky.money USDS Risk Capital",
    symbol: "skyMoneyUsdsRiskCapital",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xcf27EE38fE6D62db157B34F5c67F30c09132c481",
    version: "v2",
    name: "Test",
    symbol: "TEST",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xBEEf3f3A04e28895f3D5163d910474901981183D",
    version: "v2",
    name: "3F x Steakhouse USDC",
    symbol: "3F-steakUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xc770a57fCfBC716a1F94C414d9a62792C766E883",
    version: "v2",
    name: "Philidor USDC Prime",
    symbol: "phiUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xaA8d9E2aBa210639cE6C7cE21385e7c673ACa6f3",
    version: "v2",
    name: "Yearn USDC",
    symbol: "yNM-USDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xf842F89A478107AceF530F655861bE4BbAFaC822",
    version: "v2",
    name: "PIKA Vault",
    symbol: "PIKAPOO",
    asset: {
      address: "0xa9D54F37EbB99f83B603Cc95fc1a5f3907AacCfd",
      symbol: "PIKA",
    },
  },
  {
    id: "0xe479bCbc98579bA3E1a1261f7bE85C4C10303d88",
    version: "v2",
    name: "Sentora PYUSD Core V2",
    symbol: "senPYUSDcoreV2",
    asset: {
      address: "0x6c3ea9036406852006290770BEdFcAbA0e23A0e8",
      symbol: "PYUSD",
    },
  },
  {
    id: "0x4208be3A5Db3E990bDEF7a10D3209E01aA3Bc274",
    version: "v2",
    name: "TelosC AUSD Equities and Commodities",
    symbol: "eqcAUSD",
    asset: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
  },
  {
    id: "0x937911fbeCa47213dD6A9bce647a5d984B80096E",
    version: "v2",
    name: "USDC TEST ",
    symbol: "USDC_TEST",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x690F0bDc73b8d5e16F5B2d96e195e6bf22595f34",
    version: "v2",
    name: "CCM Atlas Prime",
    symbol: "ccmAtlasETH",
    asset: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0x29CA54dd3Ae9E43aBb10880f5E08da439Bf25F99",
    version: "v2",
    name: "DeTrade Serenity USDC",
    symbol: "dt-eth-serenityUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x842A84Df61DbE701c5dAE345F3f8E64aF727E48C",
    version: "v2",
    name: "Gauntlet EURC Core",
    symbol: "gteurcc",
    asset: {
      address: "0x1aBaEA1f7C830bD89Acc67eC4af516284b1bC33c",
      symbol: "EURC",
    },
  },
  {
    id: "0x453CD0425B571902718574cF5a6f30c1699a3006",
    version: "v2",
    name: "Blend USDC",
    symbol: "blend-usdc",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x197703794ee88D8FC66108D878444f5a26c748d1",
    version: "v2",
    name: "Blend PT srUSDe-2APR2026",
    symbol: "blend-srUSDe-2APR2026",
    asset: {
      address: "0x9Bf45ab47747F4B4dD09B3C2c73953484b4eB375",
      symbol: "PT-srUSDe-2APR2026",
    },
  },
  {
    id: "0x00721c8bb486ad403D662C769Cf640C74C0439A4",
    version: "v2",
    name: "Blend PT jrUSDe-2APR2026",
    symbol: "blend-jrUSDe-2APR2026",
    asset: {
      address: "0xd0609Ac13000d88B0BEbf5Bb21074916eDd92Bb1",
      symbol: "PT-jrUSDe-2APR2026",
    },
  },
  {
    id: "0x132Fe294ea9b6faD8cA00554D211d5F2b905c1AD",
    version: "v2",
    name: "Avantgarde WETH Conservative",
    symbol: "AVGWETHcons",
    asset: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0xf42bca228D9bd3e2F8EE65Fec3d21De1063882d4",
    version: "v2",
    name: "sky.money USDS Risk Capital",
    symbol: "skyMoneyUsdsRiskCapital",
    asset: {
      address: "0xdC035D45d973E3EC169d2276DDab16f1e407384F",
      symbol: "USDS",
    },
  },
  {
    id: "0x9f39B13bB472126D6937Bf25A39338E664eeFa82",
    version: "v2",
    name: "Alpha USDC Prime V2",
    symbol: "alphaUSDCPrimeV2",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xBEeFF047C03714965a54b671A37C18beF6b96210",
    version: "v2",
    name: "Steakhouse Reservoir USDC",
    symbol: "bbqSUDCreservoir",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xf1CA44EEa3A4eFFcB195A970a2f1d8553f76F9A1",
    version: "v2",
    name: "Alpha USDC Core V2",
    symbol: "alphaUSDCCoreV2",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xBEEFf072E9EFdc7c819b374066DD876b334210A3",
    version: "v2",
    name: "Steakhouse Reservoir USDC",
    symbol: "bbqUSDCreservoir",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x6efF1A518b0656c5aC9376B25318784b64A27C11",
    version: "v2",
    name: "Duplicated Key",
    symbol: "DPK.ETH.v2",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x2679f32C0FF31e3d09DE6d2046D15F8fB7173f6e",
    version: "v2",
    name: "Pocky's High Yield EURCV V2",
    symbol: "PHYEURCVV2",
    asset: {
      address: "0x5F7827FDeb7c20b443265Fc2F40845B715385Ff2",
      symbol: "EURCV",
    },
  },
  {
    id: "0xF39AC02DEc8faE8292d5f42202e4Cd885356256B",
    version: "v2",
    name: "SingularV ETH",
    symbol: "svETH",
    asset: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0xf7c83eD78D1dcAd6736F9f74C8A2293314441De6",
    version: "v2",
    name: "SingularV USDT",
    symbol: "svUSDT",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0xFa17f7AAdbfAc2C5d3C8125555404c1AE17Df853",
    version: "v2",
    name: "Clearstar Yield USDC",
    symbol: "CSYUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x396153bed69a2263183107E613c527B5476e6b0e",
    version: "v2",
    name: "Clearstar Reactor ETH",
    symbol: "CSRETH",
    asset: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0xae9A5aa54ae43BB8811435F02A29E9d2B43CDC7C",
    version: "v2",
    name: "Clearstar Reactor ETH",
    symbol: "CSRETH",
    asset: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0x9C605F8cbb74C7D00cE46Ff81de68A313AC17192",
    version: "v2",
    name: "DeTrade Serenity EURC",
    symbol: "dt-serenityEURC",
    asset: {
      address: "0x1aBaEA1f7C830bD89Acc67eC4af516284b1bC33c",
      symbol: "EURC",
    },
  },
  {
    id: "0xBEEfF0d672ab7F5018dFB614c93981045D4aA98a",
    version: "v2",
    name: "Grove x Steakhouse AUSD",
    symbol: "grove-bbqAUSD",
    asset: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
  },
  {
    id: "0xB33E87f90323ecF2E3196B865302e070B4507DBf",
    version: "v2",
    name: "Maxshot USDC",
    symbol: "mUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x70D4aC733E1ea63d42A981293407ABbC5f534390",
    version: "v2",
    name: "Ellen Capital - USDC Prime",
    symbol: "ePrimeUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x827F945F10fE304877f1bB567BC1c7F565E25bf7",
    version: "v2",
    name: "Maxshot USDT0",
    symbol: "mUSDT0",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0xD281ed26059E3510577098A599c9d34DA74AA75B",
    version: "v2",
    name: "Test1236",
    symbol: "test1236usdc",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x951a9f4A2cE19B9DeA6B37e691d076A345b6c0F8",
    version: "v2",
    name: "Alpha USDC Enhanced V2",
    symbol: "alphaUSDCEnhancedV2",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x610f5B68bD1EED68Af649A3fD3DC2CAa1ee4Ae7E",
    version: "v2",
    name: "Alpha LINK Enhanced V2",
    symbol: "alphaLINKEnhancedV2",
    asset: {
      address: "0x514910771AF9Ca656af840dff83E8264EcF986CA",
      symbol: "LINK",
    },
  },
  {
    id: "0x057F46a0222B84b7b951Cb9A1Ff189E63B8E13b6",
    version: "v2",
    name: "Hadjime USDC Prime",
    symbol: "USDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x2f965159Ead23c588F3EFcfF285e1b85Eb57e4C3",
    version: "v2",
    name: "B4B_t",
    symbol: "B4B_t",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xbeef003E31546C7210687f1A7b40d096BE83ec58",
    version: "v2",
    name: "Steakhouse Prime EURC",
    symbol: "steakEURC",
    asset: {
      address: "0x1aBaEA1f7C830bD89Acc67eC4af516284b1bC33c",
      symbol: "EURC",
    },
  },
  {
    id: "0x509289cCa7Fe28CC34629445CCF658Ac310e6f60",
    version: "v2",
    name: "Pangolins USDC",
    symbol: "pUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x413290c60f754e37Ae3266da85d75489133F255A",
    version: "v2",
    name: "mvUSDT",
    symbol: "mvUSDT",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0xB857C44Ceee3FEC4A468A6f4C36e6EF320F81EEF",
    version: "v2",
    name: "mvUSDC",
    symbol: "mvUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x18032C694f8ebfdcc030cB8C54c3701a107c2F72",
    version: "v2",
    name: "OV USDC",
    symbol: "ovusdc",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xD547DA208F29c36682872407f8032BDa878d42b7",
    version: "v2",
    name: "BruvskiTest",
    symbol: "$BRUV",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x8C8F6d3c9b647afb942B4Ac0C28818F0674a0F01",
    version: "v2",
    name: "OV USDT",
    symbol: "ovusdt",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0x60BfF627bD38896456834D81aB8faE7f5D03dA6F",
    version: "v2",
    name: "Babylonian WETH Prime Discount",
    symbol: "bWETHpd",
    asset: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0xb789265cf021A9E290f69a07dE4F0E32D6372665",
    version: "v2",
    name: "USDC_AI",
    symbol: "UAI",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xF3Cc5c9A25508D8d959618fd48F6AbC18cA4Db49",
    version: "v2",
    name: "Clearstar Boring USDC",
    symbol: "CSBUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xd7B96aF2EBe299bB4ED8C03946163732f6A463Ca",
    version: "v2",
    name: "Foundation Core K",
    symbol: "FCK",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xc71f3BAaeBd3fa9c5716fC66b89493ae66BeAc50",
    version: "v2",
    name: "Pocky's High Yield USDC V2 Eth",
    symbol: "PHYUSDCV2ETH",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x2B58132964f038461E3D8b56df582f49FEcc8745",
    version: "v2",
    name: "Clearstar Boring USDT",
    symbol: "CSBUSDT",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0x14A90D27338f40E22E1458A92934061cCAe144fC",
    version: "v2",
    name: "HavenFi EURC - Core",
    symbol: "hfEURC",
    asset: {
      address: "0x1aBaEA1f7C830bD89Acc67eC4af516284b1bC33c",
      symbol: "EURC",
    },
  },
  {
    id: "0x8D5b25930799751FB6B288818500ECda66c56254",
    version: "v2",
    name: "DeTrade Serenity WETH",
    symbol: "dt-serenityWETH",
    asset: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0x6624c638780816228a25a15A4f30287d30c459C2",
    version: "v2",
    name: " ARCHITECT Global Value",
    symbol: " ARCHITECT GVI",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x5E27F0a16d761fD702Ab7cd96c093a5393136b87",
    version: "v2",
    name: "Test Free Wrapper",
    symbol: "TFW",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x98Cb4e70ded66FC55b795Af710c05A3d7c593Ed1",
    version: "v2",
    name: "tGLD USDC Vault",
    symbol: "tGLDv-USDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x7290245b3e564f0Ae2dA5af0690eF4842CF13c75",
    version: "v2",
    name: "tGLD USDC Vault",
    symbol: "tGLDv-USDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x68B2486900f8FDBa433aBCe27Bc557023477e2b8",
    version: "v2",
    name: "USDC Conservative Vault",
    symbol: "cvUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x3a139f89b5377e5Eaf613B5f5d132D325F118b43",
    version: "v2",
    name: "panawill test vault",
    symbol: "USDCPTest",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xa01Fd84E0f1585DC299Ac8795AAb954C0ADA3817",
    version: "v2",
    name: "Revault1",
    symbol: "REV1",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xE584aA81EE567A589ab9cC93e88caBc4F2a6AE5D",
    version: "v2",
    name: "Revault2",
    symbol: "REV2",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0xEa05c873CC17Ab5AbB57f700C68d962D6a0DE33b",
    version: "v2",
    name: "Revault3",
    symbol: "REV3",
    asset: {
      address: "0x1aBaEA1f7C830bD89Acc67eC4af516284b1bC33c",
      symbol: "EURC",
    },
  },
  {
    id: "0xbEef00e64ceB8908B58025793fE46Ee2038c2315",
    version: "v2",
    name: "Techblock x Steakhouse EURCV",
    symbol: "techblockEURCV",
    asset: {
      address: "0x5F7827FDeb7c20b443265Fc2F40845B715385Ff2",
      symbol: "EURCV",
    },
  },
  {
    id: "0xa4816711cb16d69D3f338F3D28B8169e22830ce8",
    version: "v2",
    name: "VSG crvUSD Vault",
    symbol: "vsgCRVUSD",
    asset: {
      address: "0xf939E0A03FB07F59A73314E73794Be0E57ac1b4E",
      symbol: "crvUSD",
    },
  },
  {
    id: "0x22A8EB1801a0e1F55EE8f95D24C13873B7C9d29E",
    version: "v2",
    name: "Revault4",
    symbol: "REV4",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x1E7DE02B0c180d8E4a020aa9dE294bACfd9E6578",
    version: "v2",
    name: "Spreads Finance SPYx V2",
    symbol: "sprSPX/USDC",
    asset: {
      address: "0x90A2a4c76b5D8c0bc892A69EA28Aa775a8f2dD48",
      symbol: "SPYx",
    },
  },
  {
    id: "0x2086eB7beAbB123961A940bDC0b018A43De02A85",
    version: "v2",
    name: "NuWealth Anchor USDC",
    symbol: "nuUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x6d387c4756610682C4E562c636dac46ac40780c8",
    version: "v2",
    name: "NuWealth Anchor USDT",
    symbol: "nuUSDT",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0x02D2488A2292C25D0D313A1b8D882A2d28E74598",
    version: "v2",
    name: "NuWealth Anchor EURC",
    symbol: "nuEURC",
    asset: {
      address: "0x1aBaEA1f7C830bD89Acc67eC4af516284b1bC33c",
      symbol: "EURC",
    },
  },
  {
    id: "0xE15fcC81118895b67b6647BBd393182dF44E11E0",
    version: "v2",
    name: "sky.money USDS Flagship",
    symbol: "skyMoneyUsdsFlagship",
    asset: {
      address: "0xdC035D45d973E3EC169d2276DDab16f1e407384F",
      symbol: "USDS",
    },
  },
  {
    id: "0xd8CD72A2eB7A4312404C00AeD5172C0026da0C27",
    version: "v2",
    name: "Alpha Frax USD Enhanced V2",
    symbol: "alphaFraxUSDenhanced",
    asset: {
      address: "0xCAcd6fd266aF91b8AeD52aCCc382b4e165586E29",
      symbol: "frxUSD",
    },
  },
  {
    id: "0x569C9Af18412D1cDe35c9eA918420F0F5d60B807",
    version: "v2",
    name: "Rini USDC Oak",
    symbol: "RUO",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xa7BD284FD921BC0219ad4ffe3F943bEA3fc4319B",
    version: "v2",
    name: "USDT Strategy ",
    symbol: "strgyUSDT",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0xBEef009f900feD83d52048556122338aADDA8fe9",
    version: "v2",
    name: "Techblock x Steakhouse EURCV",
    symbol: "techblockEURCV",
    asset: {
      address: "0x5F7827FDeb7c20b443265Fc2F40845B715385Ff2",
      symbol: "EURCV",
    },
  },
  {
    id: "0xBEeF007ECFBfdF9B919d0050821A9B6DbD634fF0",
    version: "v2",
    name: "Techblock x Steakhouse EURCV",
    symbol: "techblockEURCV",
    asset: {
      address: "0x5F7827FDeb7c20b443265Fc2F40845B715385Ff2",
      symbol: "EURCV",
    },
  },
  {
    id: "0xCE13e39534082FCF8f13F6D84e6D95414D14271e",
    version: "v2",
    name: "Stake DAO frxUSD v2",
    symbol: "sdFRXUSDv2",
    asset: {
      address: "0xCAcd6fd266aF91b8AeD52aCCc382b4e165586E29",
      symbol: "frxUSD",
    },
  },
  {
    id: "0xc7CDcFDEfC64631ED6799C95e3b110cd42F2bD22",
    version: "v2",
    name: "Spark Blue Chip USDT Vault",
    symbol: "sparkUSDTbc",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0xCf3B48cF1748758D2653300300Df3f92915006d6",
    version: "v2",
    name: "High",
    symbol: "Hi",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xF7c3A485ED9Ec23d22686D03440EBC6e3C87920F",
    version: "v2",
    name: "Flowdesk AUSD Equity Strategy",
    symbol: "fAUSDe",
    asset: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
  },
  {
    id: "0x758aaF09e1147e68c01Ca397d12293aB744C6161",
    version: "v2",
    name: "Steakhouse High Yield Turbo AUSD",
    symbol: "bbqAUSDturbo",
    asset: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
  },
  {
    id: "0x89816d51bcB9bD2DE97719Adaa9eFaaC32653E86",
    version: "v2",
    name: "Steakhouse High Yield Turbo AUSD",
    symbol: "bbqAUSDturbo",
    asset: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
  },
  {
    id: "0xBEEFFF7e4EedD83A4a4aB53A68D03eC77C9a57a8",
    version: "v2",
    name: "Steakhouse High Yield Turbo AUSD",
    symbol: "bbqAUSDturbo",
    asset: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
  },
  {
    id: "0xFe1456aa6d05c050BB922092B6C99eC8bAfd4e70",
    version: "v2",
    name: "Steakhouse High Yield Term AUSD",
    symbol: "bbqAUSDterm",
    asset: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
  },
  {
    id: "0xBEEFF0DeaC1aBa71EF0D88C4291354eb92ef4589",
    version: "v2",
    name: "Steakhouse High Yield Term AUSD",
    symbol: "bbqAUSDterm",
    asset: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
  },
  {
    id: "0xF03C521F3F1D122ffFEF451936D483EAB95BE17c",
    version: "v2",
    name: "Steakhouse Prime frxUSD",
    symbol: "steakFRXUSD",
    asset: {
      address: "0xCAcd6fd266aF91b8AeD52aCCc382b4e165586E29",
      symbol: "frxUSD",
    },
  },
  {
    id: "0xbeef009FF4FB1727297BF2526806F4A73E4b99aD",
    version: "v2",
    name: "Steakhouse Prime frxUSD",
    symbol: "steakFRXUSD",
    asset: {
      address: "0xCAcd6fd266aF91b8AeD52aCCc382b4e165586E29",
      symbol: "frxUSD",
    },
  },
  {
    id: "0x56bfa6f53669B836D1E0Dfa5e99706b12c373ecf",
    version: "v2",
    name: "sky.money USDC Risk Capital",
    symbol: "skyMoneyUsdcRiskCapital",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x2bD3A43863c07B6A01581FADa0E1614ca5DF0E3d",
    version: "v2",
    name: "sky.money USDT Risk Capital",
    symbol: "skyMoneyUsdtRiskCapital",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0x153Bd1abE60104Bd46aa05a27fA12D1346D64A57",
    version: "v2",
    name: "Alpha USDC Forex V2",
    symbol: "alphaForexV2",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xC9D7B729AdFB2D3F837E0C15b63a252c74224A7e",
    version: "v2",
    name: "HavenFi Balanced USDC (Mainnet)",
    symbol: "hfUSDCbalancedEth",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x6D5B44a162C60EfD4A87C8A2431aB77c26667c8D",
    version: "v2",
    name: "TEST USDe Vault",
    symbol: "TEST_USDe_Vault",
    asset: {
      address: "0x4c9EDD5852cd905f086C759E8383e09bff1E68B3",
      symbol: "USDe",
    },
  },
  {
    id: "0x77Df2575Eb4Cac4a0E47166b5219879d5023E7cA",
    version: "v2",
    name: "TEST USDe Vault",
    symbol: "TEST_USDe_Vault",
    asset: {
      address: "0x4c9EDD5852cd905f086C759E8383e09bff1E68B3",
      symbol: "USDe",
    },
  },
  {
    id: "0xdFa838353618Da83DF98F5B4b457E881B7f79b0f",
    version: "v2",
    name: "TEST USDe Vault",
    symbol: "TEST_USDe_Vault",
    asset: {
      address: "0x4c9EDD5852cd905f086C759E8383e09bff1E68B3",
      symbol: "USDe",
    },
  },
  {
    id: "0xDde88620e613B69ea6deFdEd8B153C1C0b976475",
    version: "v2",
    name: "kMUSDStrat",
    symbol: "kMUStrat",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xa3ae5746b21De27A44944097D8Fe96fe2cF9a437",
    version: "v2",
    name: "YF x Unified Labs USDC",
    symbol: "YFUni",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x8E56CB6Bc1a8961ed9062B99045D3299b27CDb4D",
    version: "v2",
    name: "Avantgarde USDC Dynamic",
    symbol: "AVGUSDCdyn",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x42Cd15137cC85FA7e114Ab0D63Fd1d6770c004a3",
    version: "v2",
    name: " tsetm",
    symbol: " tsetm",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x454706aa25B2d0D0d0328679e630fdEd7CDfbc9c",
    version: "v2",
    name: "USDC PRIME",
    symbol: "gtUSDCpx",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x96D8cF81acAD83E533b3Ad4Fb039f145BED1C14F",
    version: "v2",
    name: "USDC PRIME",
    symbol: "gtUSDCpx",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xfaAd1a890Ef7557Ca62655B76CDDaF6F42d3C738",
    version: "v2",
    name: "USDT PRIME",
    symbol: "gtUSDTpx",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0x7aED0d1A530258F3F6eAb891F293d7F52d26DB06",
    version: "v2",
    name: "USDT PRIME",
    symbol: "gtUSDTpx",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0x78d4A8fdE3b7b371f9C1830Ba139f8193d13a10E",
    version: "v2",
    name: "USDT PRIME",
    symbol: "gtUSDTpx",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0x41A56BC3738F98EC919bf130Fb69DcBB942c4D68",
    version: "v2",
    name: "USDT PRIME",
    symbol: "gtUSDTpx",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0x36cfe1568461E499391ef0A555300F1ae2da2439",
    version: "v2",
    name: "Api3 dCOMP USDC",
    symbol: "Api3-dCOMP-USDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x55c07EC292a96b93015367F7372ADA773bdfD8fE",
    version: "v2",
    name: "sky.money USDT Savings",
    symbol: "skyMoneyUsdtSavings",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0x23f5E9c35820f4baB695Ac1F19c203cC3f8e1e11",
    version: "v2",
    name: "sky.money USDT Savings",
    symbol: "skyMoneyUsdtSavings",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0x1cC6A6111feC40eb8DEA478bcc2c0A099365F3d2",
    version: "v2",
    name: "Vault Name",
    symbol: "vUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x2fcF14f338BB302E4525625FC751DE54f3D5613e",
    version: "v2",
    name: "Vault Name",
    symbol: "vUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x9B08469CCfEa991E17d7EB9D883C43fE2cE2Ff89",
    version: "v2",
    name: "Vault Name",
    symbol: "vUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xE080b9deE72C2B753d807Aa47509A010Ba06dc51",
    version: "v2",
    name: "Morpho USDC Vault Fee Wrapper",
    symbol: "vaultUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x0691F32ba24757C591D07121dE63559E4a108184",
    version: "v2",
    name: "Morpho USDC Vault Fee Wrapper",
    symbol: "vaultUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x3F8Ae96fA5a959244EaBc56CDa95b4863E65d2Fd",
    version: "v2",
    name: "Morpho USDC Vault Fee Wrapper",
    symbol: "vaultUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x6dC58a0FdfC8D694e571DC59B9A52EEEa780E6bf",
    version: "v2",
    name: "Sentora RLUSD Main",
    symbol: "senRLUSDv2",
    asset: {
      address: "0x8292Bb45bf1Ee4d140127049757C2E0fF06317eD",
      symbol: "RLUSD",
    },
  },
  {
    id: "0xaDE901e905193B9F30f61ddD9DFd8E0815ee25da",
    version: "v2",
    name: "Strategic USDC Yield Vault",
    symbol: "STRGY",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xDB2035e7fcEA6Ee957609c874c85e5De48927c35",
    version: "v2",
    name: "Halalcash Levered Tether USD",
    symbol: "HALALUSDT",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0x297f388D90060c07C017749938B400432FEE7B22",
    version: "v2",
    name: "WETH PRIME",
    symbol: "xweth",
    asset: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0x4522c5a7917e9f96F14FA2661b721a95280b9FF7",
    version: "v2",
    name: "WETH PRIME",
    symbol: "xweth",
    asset: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0xFd70693888Be43fA07589B95901b06010516fD5d",
    version: "v2",
    name: "NuWealth Anchor RLUSD",
    symbol: "nuRLUSD",
    asset: {
      address: "0x8292Bb45bf1Ee4d140127049757C2E0fF06317eD",
      symbol: "RLUSD",
    },
  },
  {
    id: "0x8A9f4605394CcE926Fa9BffaAAD3f31D942cf533",
    version: "v2",
    name: "NuWealth Anchor PYUSD",
    symbol: "nuPYUSD",
    asset: {
      address: "0x6c3ea9036406852006290770BEdFcAbA0e23A0e8",
      symbol: "PYUSD",
    },
  },
  {
    id: "0x04C5F310d479aDC5EA2D21695765A61b7E2726e7",
    version: "v2",
    name: "Polymarket's oracle UMA",
    symbol: "UMA.rocks",
    asset: {
      address: "0x04Fa0d235C4abf4BcF4787aF4CF447DE572eF828",
      symbol: "UMA",
    },
  },
  {
    id: "0xc0E0882Dd2DADAc322510538CD5088a38cE52b69",
    version: "v2",
    name: "Blend USDC",
    symbol: "blend-usdc",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xC363EA35D7F38B1d7f3c620Fd66aeDD545e2a637",
    version: "v2",
    name: "ThirdGuard USDC Prime",
    symbol: "tgUSDCp",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x65D217B44aDe6a55984E868cBCFd55D1343A8e1E",
    version: "v2",
    name: "discarded",
    symbol: "discarded",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0x2F99e35Ea811F3cC230B26dfF817604B5D4B6e38",
    version: "v2",
    name: "ByzPrime EUR",
    symbol: "byzEUR",
    asset: {
      address: "0x1aBaEA1f7C830bD89Acc67eC4af516284b1bC33c",
      symbol: "EURC",
    },
  },
  {
    id: "0x3399F04381F58E1bF190D6b20474dCB339FC6F9d",
    version: "v2",
    name: "Morpho USDC Vault Fee Wrapper",
    symbol: "vaultUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xBEeFf08E1887A11D91B9Ca68c133c08Ae3c4B44f",
    version: "v2",
    name: "Steakhouse Reservoir rUSD",
    symbol: "bbqRUSDreservoir",
    asset: {
      address: "0x09D4214C03D01F49544C0448DBE3A27f768F2b34",
      symbol: "rUSD",
    },
  },
  {
    id: "0x870F0BF29A25A40E7CC087cD5C53e70C11F2C8A8",
    version: "v2",
    name: "KPK USDT Prime",
    symbol: "KPK_USDT_Prime",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0x9CAe2726D0A403bd61Ef72A6876503329A638A40",
    version: "v2",
    name: "USDT Vault",
    symbol: "mmUSDT",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0x37Cf7c7D80a2eEA813Af6a115fA63Df23862a1E7",
    version: "v2",
    name: "RockawayX USDC Prime",
    symbol: "roxpUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xB9a95828E9471C815e12541c5CC1244BC208c4C2",
    version: "v2",
    name: "Julian Capital USDC Balanced",
    symbol: "JULIANUSDCBAL",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x87c221938F2Ce88B72EFcC8480e163AD7BD61a23",
    version: "v2",
    name: "Speransky ",
    symbol: "USDC Alpha",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xc7265BcB1f29320001dB32CE8C54DE99Dd9bB6D1",
    version: "v2",
    name: "gtsy-eth",
    symbol: "GETH1",
    asset: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0xeb6719c14BA01Bf1D6bFB78A65F63f12FabF202C",
    version: "v2",
    name: "Alpha APXUSD V2",
    symbol: "alphaAPXUSDV2",
    asset: {
      address: "0x98A878b1Cd98131B271883B390f68D2c90674665",
      symbol: "apxUSD",
    },
  },
  {
    id: "0xf5bb58F088f06F3060BdDf16e93156273CE3FBB7",
    version: "v2",
    name: "RockawayX USDC Prime",
    symbol: "roxUSDCp",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xBFd9b6897fE93eD8b2B1A3Aa6a3DEB5D2a14f74F",
    version: "v2",
    name: "RockawayX USDC Yield",
    symbol: "roxUSDCy",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x61584E6fC18B39E4799787C4E52Dd3b265d4dcDD",
    version: "v2",
    name: "RockawayX wETH",
    symbol: "roxWETH",
    asset: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0x32401B9fb79065Bc15949DE0BD43927492f02F0C",
    version: "v2",
    name: "Flowdesk AUSD RWA Strategy",
    symbol: "fAUSDe",
    asset: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
  },
  {
    id: "0x51F5D4686e39275AF71DE605AD333067E7017aE3",
    version: "v2",
    name: "Markov USDC Prime",
    symbol: "mkmUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xbeeff9eBE518d1C7E552c4BbfB99487435c4dEc9",
    version: "v2",
    name: "Steakhouse Resolv USR",
    symbol: "bbqUSRresolv",
    asset: {
      address: "0x66a1E37c9b0eAddca17d3662D6c05F4DECf3e110",
      symbol: "USR",
    },
  },
  {
    id: "0xD3CfFB7B62bae7abF6618cC5c1F160Dfa826110C",
    version: "v2",
    name: "G12 Labs Stable Yield",
    symbol: "uG12",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x0fC4f2cF88670D3ABF741695411906bc51B8fB68",
    version: "v2",
    name: "Prime USDC",
    symbol: "primeUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x35Cbe8542E70fa2f7F9cDF129F19e593F4b4f560",
    version: "v2",
    name: "Alpha USDC Asia V2",
    symbol: "alphaUSDCAsiaV2",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xBEEFFFDE1CABD3d8A3cd4fd5e04DbA51B9D4Ac39",
    version: "v2",
    name: "Steakhouse High Yield Turbo XAUT",
    symbol: "bbqXAUTturbo",
    asset: {
      address: "0x68749665FF8D2d112Fa859AA293F07A622782F38",
      symbol: "XAUt",
    },
  },
  {
    id: "0xcd726DBb3Fa43A93377866Ccfddf165cd82185Cc",
    version: "v2",
    name: "Gauntlet PYUSD",
    symbol: "gtpyusd",
    asset: {
      address: "0x6c3ea9036406852006290770BEdFcAbA0e23A0e8",
      symbol: "PYUSD",
    },
  },
  {
    id: "0x38181D2421A00e34618b3108A8B1C031a164a935",
    version: "v2",
    name: "Gauntlet PYUSD",
    symbol: "gtpyusd",
    asset: {
      address: "0x6c3ea9036406852006290770BEdFcAbA0e23A0e8",
      symbol: "PYUSD",
    },
  },
  {
    id: "0x437a4A671286569e3Be9a09dd3ef731405032E71",
    version: "v2",
    name: "RBC-pmUSD",
    symbol: "RBC-pmUSD",
    asset: {
      address: "0xC0c17dD08263C16f6b64E772fB9B723Bf1344DdF",
      symbol: "pmUSD",
    },
  },
  {
    id: "0x2B70FEc5c8D32E9D2d9d45d776a16Ca3108C7836",
    version: "v2",
    name: "Test",
    symbol: "vTest",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x97e006d1a6313dfb4Ae27edfF73b06b352091f9E",
    version: "v2",
    name: "Test Vault",
    symbol: "tv",
    asset: {
      address: "0x06ea695B91700071B161A434fED42D1DcbAD9f00",
      symbol: "hemiBTC",
    },
  },
  {
    id: "0x64F35F6025bFbdDF667f76E21D10A6BfeE61748B",
    version: "v2",
    name: "ThirdGuard USDC Prime",
    symbol: "tgUSDCp",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x4F55F2b5C98590D1C45E52E8EF1b7a49eA414019",
    version: "v2",
    name: "Gated Test",
    symbol: "gatedUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x6f48cE6380693808682E43140E3Eeb877a096Aa1",
    version: "v2",
    name: "Gated Test",
    symbol: "gatedUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x5034518e0AE0479ED595d4A013d67c00886e14f4",
    version: "v2",
    name: "USX Mainnet USDC",
    symbol: "usx-mainnet-usdc",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xb133Bbf63b7e62Af3fe255E394F741fDEFA01F09",
    version: "v2",
    name: "Obsidian USDC",
    symbol: "obUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x5f829B1B473cBA86838E1B7BB7E144DbDE228e21",
    version: "v2",
    name: "RockawayX USDC Prime",
    symbol: "roxpUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xc561466Bd078D5d1C94AB25d83efBDA1DAC8Dcc8",
    version: "v2",
    name: "wETH",
    symbol: "roxWETH",
    asset: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0x64C18DCC4Ccb3b8D27877a4aeBB4C3126CB39cB9",
    version: "v2",
    name: "RockawayX wETH",
    symbol: "roxWETH",
    asset: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0xE0181090c22579B6A217f1522cbf8c9f1F0C1965",
    version: "v2",
    name: "RockawayX USDC Yield",
    symbol: "roxUSDCy",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x6283C40558521515595cbCc573f8A0489Ab4d1E7",
    version: "v2",
    name: "VETRO VUSD Meta Vault",
    symbol: "VUSDmeta",
    asset: {
      address: "0xCa83DDE9c22254f58e771bE5E157773212AcBAc3",
      symbol: "VUSD",
    },
  },
  {
    id: "0x33d3a6768e099e1007f75726E47dE19AcdcC8e2c",
    version: "v2",
    name: "attempt",
    symbol: "attempt",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x991B834d51a5984da8849448F6711C04505BEfE1",
    version: "v2",
    name: "Ditobanx Mainnet USDC",
    symbol: "ditobanx-mainnet-usdc",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xECB56881B719E50F59F74c9c5A6908165a0cB510",
    version: "v2",
    name: "Blend Mainnet USDC",
    symbol: "blend-mainnet-usdc",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x485E796E2BAc3c1834D1a6D936F166a8AB732031",
    version: "v2",
    name: "Spark Blue Chip USDT Vault",
    symbol: "sparkUSDTbc",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0xb0c424116172B55CbB6dD3136F5989F7959e5B91",
    version: "v2",
    name: "Spark Blue Chip USDT Vault",
    symbol: "sparkUSDTbc",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0x885984Bd7A15ADed423096fa1B82C556e8Bb30fD",
    version: "v2",
    name: "ByzPrime USD",
    symbol: "byzUSDsam",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xD827F29506a10a64C5CC75993d8Ef58dAAF7746a",
    version: "v2",
    name: "ByzPrime USD (insured)",
    symbol: "byzUSDisam",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x15022756B004C560D8155Bc468150427fb0113d2",
    version: "v2",
    name: "VETRO VUSD Gated Vault",
    symbol: "VUSDgated",
    asset: {
      address: "0xCa83DDE9c22254f58e771bE5E157773212AcBAc3",
      symbol: "VUSD",
    },
  },
  {
    id: "0x40f1f4B146CB5E0E6FCE3a01Aa1257d40b9d1dE7",
    version: "v2",
    name: "040426test",
    symbol: "0404",
    asset: {
      address: "0x514910771AF9Ca656af840dff83E8264EcF986CA",
      symbol: "LINK",
    },
  },
  {
    id: "0x3Fb8Facab475f374129aFcCFb9a19868AA9D4E27",
    version: "v2",
    name: "CurveYield Morpho crvUSD",
    symbol: "cymcrvUSD",
    asset: {
      address: "0xf939E0A03FB07F59A73314E73794Be0E57ac1b4E",
      symbol: "crvUSD",
    },
  },
  {
    id: "0x91600E31fBeDc72433d4a57F16639cfe661Be7d8",
    version: "v2",
    name: "Galaxy USDC Quality",
    symbol: "gUSDCq",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x71ffB6a81786eC285D429d531Cf655107B9D878d",
    version: "v2",
    name: "Galaxy USDT Quality",
    symbol: "gUSDTq",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0xB54CC3fEA2dF523a7a203973e53b65938d464B73",
    version: "v2",
    name: "Stratum Test",
    symbol: "sSTRT",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xF8FFAde1189563d194F876C337dFca30e946EF88",
    version: "v2",
    name: "Fiber USDC",
    symbol: "fUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x273d7448fC090d645c2DEfAecf7510d2eAe4Be8d",
    version: "v2",
    name: "DEPRECIATED",
    symbol: "DEAD",
    asset: {
      address: "0x0655977FEb2f289A4aB78af67BAB0d17aAb84367",
      symbol: "scrvUSD",
    },
  },
  {
    id: "0x1a6CE9774E6e3077218057bD0E55A1D7093ab1E9",
    version: "v2",
    name: "CurveYield Market Lending scrvUSD ",
    symbol: "cym-scrvUSD",
    asset: {
      address: "0x0655977FEb2f289A4aB78af67BAB0d17aAb84367",
      symbol: "scrvUSD",
    },
  },
  {
    id: "0x866C2FDe43BEcf872491399f8bE5E67fc6c598DC",
    version: "v2",
    name: "CurveYield Market Lending scrvUSD",
    symbol: "cym-scrvUSD",
    asset: {
      address: "0x0655977FEb2f289A4aB78af67BAB0d17aAb84367",
      symbol: "scrvUSD",
    },
  },
  {
    id: "0xeD7603DF0d6D7387d42D05fAC92CB42C4a275744",
    version: "v2",
    name: "ByzPrime EUR (insured)",
    symbol: "byzEURi",
    asset: {
      address: "0x1aBaEA1f7C830bD89Acc67eC4af516284b1bC33c",
      symbol: "EURC",
    },
  },
  {
    id: "0x6974DED9fd2b3615f5a4672104156c87133B186E",
    version: "v2",
    name: "Amolis apxUSD",
    symbol: "AM-apxUSD",
    asset: {
      address: "0x98A878b1Cd98131B271883B390f68D2c90674665",
      symbol: "apxUSD",
    },
  },
  {
    id: "0x6Bb9d07BE70d5C2c80C30B469759be92F6405C6b",
    version: "v2",
    name: "Fee Wrapper 1 USDCq",
    symbol: "fbgUSDCq",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xF4C5F89161DFB982fDf8cE1a14d1D943687C78b2",
    version: "v2",
    name: "Fee Wrapper 1 USDTq",
    symbol: "fbgUSDTq",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0x0f2D09BAaF6Ec571788cF65A5787d5F45c8e6bB5",
    version: "v2",
    name: "Fee Wrapper 1 USDTq",
    symbol: "fbgUSDTq",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0xA8bE6eB833734Bd97D9118ee76beb116ed8d9475",
    version: "v2",
    name: "testing123",
    symbol: "test",
    asset: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
  },
  {
    id: "0xbeef08244D4885ceD2760cC9d4c6eA5693dcf1Bb",
    version: "v2",
    name: "Steakhouse Prime Instant tGBP",
    symbol: "steakTGBP",
    asset: {
      address: "0x27f6c8289550fCE67f6B50BeD1F519966aFE5287",
      symbol: "tGBP",
    },
  },
  {
    id: "0xbeef06Fc20699603b995bab8AB03a0592BB4C12f",
    version: "v2",
    name: "Steakhouse Prime Instant tGBP",
    symbol: "steakTGBP",
    asset: {
      address: "0x27f6c8289550fCE67f6B50BeD1F519966aFE5287",
      symbol: "tGBP",
    },
  },
  {
    id: "0xbeef0c68466183937a22e1F414E8789a45032302",
    version: "v2",
    name: "Steakhouse Prime Instant tGBP",
    symbol: "steakTGBP",
    asset: {
      address: "0x27f6c8289550fCE67f6B50BeD1F519966aFE5287",
      symbol: "tGBP",
    },
  },
  {
    id: "0x594Be6816Ff2EEae7Db4f3EA8F9e81F0CCc94444",
    version: "v2",
    name: "CurveYield scrvUSD Lending",
    symbol: "cylscrvUSD",
    asset: {
      address: "0x0655977FEb2f289A4aB78af67BAB0d17aAb84367",
      symbol: "scrvUSD",
    },
  },
  {
    id: "0x0bF0164D17469241B6E086dA4016DCc54FEAA334",
    version: "v2",
    name: "Alpha USDC Delta V2",
    symbol: "alphaUSDCDeltaV2",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xa5778AeD7943354A953B69E4F735e479217E600e",
    version: "v2",
    name: "Test",
    symbol: "Test",
    asset: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0xa511d618cD0F9d7cAD791009d7c5E3b19c9568da",
    version: "v2",
    name: "Test Steakhouse USDC Prime",
    symbol: "tstSHUSDCp",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xe44B314E95A40a590975fc878DaBd0C76C25A366",
    version: "v2",
    name: "ByzPrime USD",
    symbol: "byzUSDeri",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x79Ab64382D06fd32E414A9904A7af9A185E4025a",
    version: "v2",
    name: "ByzPrime USD (insured)",
    symbol: "byzUSDieri",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x557C6B3f6904CAD286fF8eE6CB604dA397545CAD",
    version: "v2",
    name: "Philidor USDC Prime Mainnet",
    symbol: "philidor-usdc-prime-mainnet",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x4E02CB76245Ec52D6EEf6fc724e4e0a7FE8ce635",
    version: "v2",
    name: "Kravata GO Claro Mainnet USDC",
    symbol: "kravata-go-claro-mainnet-usdc",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xbeeffABcd0dB09589Dd21854aa760C52aB4bf04F",
    version: "v2",
    name: "Steakhouse tGBP",
    symbol: "bbqTGBP",
    asset: {
      address: "0x27f6c8289550fCE67f6B50BeD1F519966aFE5287",
      symbol: "tGBP",
    },
  },
  {
    id: "0x14d470C65a9EBBC5ed4BD6e6BbF0103390B7192B",
    version: "v2",
    name: "NA",
    symbol: "-",
    asset: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0x1878805799273d10aE96a58201A6f5254CF9824F",
    version: "v2",
    name: "Galaxy WETH Quality",
    symbol: "gWETHq",
    asset: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0xBeEff4fD39F8e48b6a6e475445D650cb11e9599F",
    version: "v2",
    name: "Grove x Steakhouse RLUSD",
    symbol: "grove-bbqRLUSD",
    asset: {
      address: "0x8292Bb45bf1Ee4d140127049757C2E0fF06317eD",
      symbol: "RLUSD",
    },
  },
  {
    id: "0xDa823Abb0B1F0e60CddF34039e92fBcaC9001D23",
    version: "v2",
    name: "Hackarrot USDT prime",
    symbol: "HckUSDT",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0xE4e66fd84B84477bADDBab68336568eA21F2f5B1",
    version: "v2",
    name: "Hackarrot USDT Safe",
    symbol: "HckUSDTSafe",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0x54Fe9a93830A077424EC5A295926b1C797D3cE14",
    version: "v2",
    name: "Hackarrot USDC Safe",
    symbol: "HckUSDCSafe",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x244f46262D9aD408B746E74aBdD010E9002fb7eE",
    version: "v2",
    name: "UltraYield USDC Core",
    symbol: "ultraUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x1E0E01C354974828c40F72269C9299b62C71C139",
    version: "v2",
    name: "TEST WGTXX VAULT",
    symbol: "TWV",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x5dc53a23AdC9f2Bed98de6F59F7F309a7c71FF2B",
    version: "v2",
    name: "Wintermute USDC Prime",
    symbol: "armUSDCp",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xA2EAaD0D586cF9FD73bb2c09cF6A7E3e187D68cd",
    version: "v2",
    name: "Wintermute USDC Select",
    symbol: "armUSDCs",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x8DFf3bd6e914C2b44D035049687213Ef5b532863",
    version: "v2",
    name: "TEST WGTXX VAULT",
    symbol: "TWV",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x5024252D259c450e929b410a3671F56E955e2De4",
    version: "v2",
    name: "Trezor Steakhouse USDC Prime",
    symbol: "trSHUSDCp",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x9F7cF5ab663d7F013Ba4cD33f957289A16CA1c58",
    version: "v2",
    name: "Trezor Steakhouse USDC Prime",
    symbol: "trSHUSDCp",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xc753363F4EAd64A3BE413a67B49ec481f1395e73",
    version: "v2",
    name: "Trezor Steakhouse USDC Prime",
    symbol: "trSHUSDCp",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xde6c23E561F3e55846207EC45A91b777e0F7C889",
    version: "v2",
    name: "Trezor Steakhouse USDC Prime",
    symbol: "trSHUSDCp",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xE4DB1c5A1B709CE4d2adA6985D9D506e58F73829",
    version: "v2",
    name: "Trezor Steakhouse USDT Prime",
    symbol: "trSHUSDTp",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0x5bdc4caFa40c6E1c672201284AA771A059DF06a7",
    version: "v2",
    name: "Garden Market Maker",
    symbol: "gBTC",
    asset: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
  },
  {
    id: "0x1a1985F50352b58090eb36425AfdFacbaC7806F4",
    version: "v2",
    name: "KPK USDC Prime Core",
    symbol: "KPK_USDC_Prime_Core",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x85F3d81a39dF458E45d5EA20f9EB937fAafd282f",
    version: "v2",
    name: "UltraYield USDT Core",
    symbol: "ultraUSDT",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0x1a3f6C4E99cf7dDDbEff95eBe0727aD01Cc409F3",
    version: "v2",
    name: "TEST WGTXX VAULT",
    symbol: "TWV",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x1c7245863000722A71F98Dc8EBFe704579F13056",
    version: "v2",
    name: "Fiber USDC Ethereum",
    symbol: "FUSDCE",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x275762B8DD41753F5CE6AB2710d28dC84d021154",
    version: "v2",
    name: "Steakhouse High Yield ETH",
    symbol: "bbqETH",
    asset: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0x6cbF3Eed95976D226FFB0bEb09550A9407f47b60",
    version: "v2",
    name: "Steakhouse High Yield ETH",
    symbol: "bbqETH",
    asset: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0x5C43BcaDF9f5A5c9fFa48B6010272d87d5ca5408",
    version: "v2",
    name: "Byzantine Prime USD",
    symbol: "bpUSD",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x0026038A7FEfEf439D94Bd99b4A10017e839D3A7",
    version: "v2",
    name: "GOATed Vault USDC",
    symbol: "GTUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x594d91044Aa50d642C90f23F02418911D3503a30",
    version: "v2",
    name: "Yearn USDT",
    symbol: "ymv-USDT",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0xbeEFF75262b2eC16a3C62a807F02EE7627654931",
    version: "v2",
    name: "infiniFi x Steakhouse USDC",
    symbol: "bbqUSDCinfinifi",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xbeEFfc7b7d0604b4afB92628a8E4B09dc01d008A",
    version: "v2",
    name: "Steakhouse High Yield ETH",
    symbol: "bbqETH",
    asset: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0xbeeff8d3F412A586A204085Cf777867d06763b40",
    version: "v2",
    name: "Steakhouse High Yield wstETH",
    symbol: "bbqWSTETH",
    asset: {
      address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
      symbol: "wstETH",
    },
  },
  {
    id: "0x3e625e12a1d0f21bbFC771546C7e63e8c7a07b7E",
    version: "v2",
    name: "Yearn WBTC",
    symbol: "ymv-WBTC",
    asset: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
  },
  {
    id: "0x78e3F277448574CA057838a7F199DA48b7c2FAD5",
    version: "v2",
    name: "Maya Vault",
    symbol: "MAYA",
    asset: {
      address: "0xC4D461889F3ae06e97118342862251241AC24dDC",
      symbol: "MAYA",
    },
  },
  {
    id: "0x503Bc34d78288AC601dD73b6a8151954433869Fc",
    version: "v2",
    name: "Bloom Ethereum USDC",
    symbol: "BLOOMETHUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xc455221EbbF21e6aEd2F13382d1b1404Dd0c52DD",
    version: "v2",
    name: "Bloom Ethereum USDT",
    symbol: "BLOOMETHEREUMUSDT",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0xF8710d7895847306773B3A09c2D8cdD31978e161",
    version: "v2",
    name: "Maestro WBTC Market Maker",
    symbol: "mvBTC",
    asset: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
  },
  {
    id: "0x9480034D908989B006D78bDBBd7bD509c92E8bbC",
    version: "v2",
    name: "MEV CAPITAL USDC ",
    symbol: "MC-USDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xE48fc1A3fD6C3Da483FB587d6C24151E402BE02c",
    version: "v2",
    name: "Utorg USD Yield",
    symbol: "utorgYieldUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x11eE52AAC9AC5f228B5E20BDDFBa2C5C65c143eF",
    version: "v2",
    name: "Utorg USDC Prime",
    symbol: "utorgPrimeUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xC21b08C16458202593D4D9B26b9984Ee67b38BbD",
    version: "v2",
    name: "Sentora PRIME Main",
    symbol: "senPYUSDPRIMEv2",
    asset: {
      address: "0x6c3ea9036406852006290770BEdFcAbA0e23A0e8",
      symbol: "PYUSD",
    },
  },
  {
    id: "0xfA5367bF43b9FC2a9764Ed946b29F6e6150F6439",
    version: "v2",
    name: "Flowmark fGenesis",
    symbol: "fGenesis-USDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x84deBA23e37C1ddCb71BAEa3FFA4983eD1B0D012",
    version: "v2",
    name: "Fiber USDT Ethereum",
    symbol: "FUSDTE",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0x65BAdBE3Df288B29A178E616419a41750AB80951",
    version: "v2",
    name: "Unified Test vault",
    symbol: "UTV_1",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xBEEF0685e97f0999E74555CD6B15121F35aC5e97",
    version: "v2",
    name: "Steakhouse ARSs",
    symbol: "steakARSs",
    asset: {
      address: "0x9a1bFb2B9E3d1959Ed11636bc56DB0aB7b4473A9",
      symbol: "ARSs",
    },
  },
  {
    id: "0x2C8Cb6B6aA7a4c8d68863D4Cab8d5967D73d3C9E",
    version: "v2",
    name: "Growi USDT Max Sharpe",
    symbol: "GWUSDTSharpe",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0x9Eb4FeC03336Fd5A76819ac28Cd21c5e606C1827",
    version: "v2",
    name: "Growi USDT Max Yield",
    symbol: "GWUSDTYield",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0xEcC4BBF75E01380d23Fd8d4eC70046B153C0259F",
    version: "v2",
    name: "Pawsible Yield",
    symbol: "PAWS",
    asset: {
      address: "0x845f64673a2407320C2cC12e23b669DC16F7A473",
      symbol: "GRAM",
    },
  },
  {
    id: "0xd65d6E8dbC3Cd3D12418199E6f4014dB3aaa0097",
    version: "v2",
    name: "Figure USDC Main",
    symbol: "figrUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xd0634BF57921Ef4068f284F5e78A3f2623e20129",
    version: "v2",
    name: "Chaince USDC Yield",
    symbol: "chainceUSDCYield",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x3985e858545d784009c9420bd6ABeCA55Fd04117",
    version: "v2",
    name: "Unified Labs Prime USDC",
    symbol: "ULprime",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x90BC8CdefF1a918AF5E343BF63e6F8BF82b53dA9",
    version: "v2",
    name: "Bizantine USDC Yield",
    symbol: "bizUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x582cB3e2710e0975343CE8D749b46f614E94466b",
    version: "v2",
    name: "Mt Pelerin USDC ",
    symbol: "MtP-USDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xbeef08F3396079cd80ca702168afA5CF381eD587",
    version: "v2",
    name: "Steakhouse ARSs",
    symbol: "steakARSs",
    asset: {
      address: "0x9a1bFb2B9E3d1959Ed11636bc56DB0aB7b4473A9",
      symbol: "ARSs",
    },
  },
  {
    id: "0xbeef04cCAfe3FB25dEc704afe592e846B8C7fd06",
    version: "v2",
    name: "Steakhouse ARSs",
    symbol: "steakARSs",
    asset: {
      address: "0x9a1bFb2B9E3d1959Ed11636bc56DB0aB7b4473A9",
      symbol: "ARSs",
    },
  },
  {
    id: "0x3C1A2D1C5d7AcfBFb9adcB168694e2fcd6e713C1",
    version: "v2",
    name: "tBRL USDC Vault",
    symbol: "tBRLv-USDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xa7b78fbd9Ad54cAB94418978c05548317A7Ca867",
    version: "v2",
    name: "tMXN USDC Vault",
    symbol: "tMXNv-USDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xbeef099Cc772cfe744a2864BD1dfBD401F6a617D",
    version: "v2",
    name: "Confidential Steakhouse Prime USDC",
    symbol: "steakUSDCconfidential",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xbeef0969cfF911265AbCA9542d61c32146336104",
    version: "v2",
    name: "Confidential Steakhouse Prime USDC",
    symbol: "steakUSDCconfidential",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x352896eB7C2e3Fb1b9551CE859e57609CA38fb9B",
    version: "v2",
    name: "Pagga Mainnet USDC",
    symbol: "pagga-mainnet-usdc",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x30A8Ef874E984a93e4FDEdE82e0bf10F3Ee915c5",
    version: "v2",
    name: "Dipatrade Conservative Mainnet USDC",
    symbol: "dipatrade-conservative-mainnet-usdc",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x1B65Bb1C22e1C1183237AC83DecDAB1375CBE9AA",
    version: "v2",
    name: "Dipatrade Moderate Mainnet USDC",
    symbol: "dipatrade-moderate-mainnet-usdc",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xdeC7f76c144Db1B0678C87114831fb0f623Fb3c0",
    version: "v2",
    name: "Dipatrade Aggressive Mainnet USDC",
    symbol: "dipatrade-aggressive-mainnet-usdc",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x1C3F13120BcA5aeAD1c3309bB44C61fe1985d897",
    version: "v2",
    name: "SurgePay Mainnet USDC",
    symbol: "surgepay-mainnet-usdc",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x18c99055cc5c7AD5Eba94098d62958C4a9b5225d",
    version: "v2",
    name: "Avvio Mainnet USDC",
    symbol: "avvio-mainnet-usdc",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xc92A37Fd0250F4eecF092960a2F70A1334217528",
    version: "v2",
    name: "Purinta USDC",
    symbol: "PurintaUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x2901aF5F7893C7146C1e40acd09Db1c005Ed38f4",
    version: "v2",
    name: "CurrenC USDC-CRNC",
    symbol: "vUSDCCRNC",
    asset: {
      address: "0x47d13Fb0803409c7fE169A210d4e906165F1A432",
      symbol: "CRNC",
    },
  },
  {
    id: "0xad755C6C31515aEF8D2f830767D846774F7e9EA9",
    version: "v2",
    name: "Mainstreet USDC",
    symbol: "msUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x61Ac2168218737abAD9345ce78E38f6114f5e2C6",
    version: "v2",
    name: "ByzPrime USDC",
    symbol: "byzUSDman",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x5CF428471Fa062fa4Ab84f45E792418b7B275494",
    version: "v2",
    name: "ByzPrime USDC (insured)",
    symbol: "byzUSDiman",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xD254F9F09a0Ea777D42D91645614363F5F6e1373",
    version: "v2",
    name: "Anchorage/Galaxy USDC Quality",
    symbol: "agUSDCq",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x3a618E9D4159dff94E90bd6239161dE4dd7C0082",
    version: "v2",
    name: "Apyx apxUSD",
    symbol: "ApyxapxUSD",
    asset: {
      address: "0x98A878b1Cd98131B271883B390f68D2c90674665",
      symbol: "apxUSD",
    },
  },
  {
    id: "0x069662D2588fcaC24B5c209456Db965D151556f0",
    version: "v2",
    name: "Apyx USDC",
    symbol: "ApyxUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xFC011514Ee1e43002FD7e971dA1f293303c07C63",
    version: "v2",
    name: "RockawayX AUSD RWA",
    symbol: "roxausd",
    asset: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
  },
  {
    id: "0x2045bdc47e111b0d956E7E005e8955600eDaC06E",
    version: "v2",
    name: "Huma USDC Main",
    symbol: "humaUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xBe13aDb76B914a4c42dDab3751723A9B91d0e62d",
    version: "v2",
    name: "My USDS",
    symbol: "MyUSDS",
    asset: {
      address: "0xdC035D45d973E3EC169d2276DDab16f1e407384F",
      symbol: "USDS",
    },
  },
  {
    id: "0xc09fDbb00C59A08F7E64546336b481c0F82b7C4d",
    version: "v2",
    name: "ByzPrime EUR",
    symbol: "byzEURman",
    asset: {
      address: "0x1aBaEA1f7C830bD89Acc67eC4af516284b1bC33c",
      symbol: "EURC",
    },
  },
  {
    id: "0xe99A27169c2aA26a8f2757949d09Fa3f9A8f0B3B",
    version: "v2",
    name: "RockawayX Midas USDC Prime",
    symbol: "mpUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xe5D16DDf5e4810b273249D9F9ED20f3563A2Ec15",
    version: "v2",
    name: "ByzPrime EUR (insured)",
    symbol: "byzEURiman",
    asset: {
      address: "0x1aBaEA1f7C830bD89Acc67eC4af516284b1bC33c",
      symbol: "EURC",
    },
  },
  {
    id: "0x3578b9C6AeacCE23aE67432CaB75dC343A9E1f05",
    version: "v2",
    name: "test",
    symbol: "tttest",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xC248c8C8436Cd046fd701e71827611B67C9Ac45F",
    version: "v2",
    name: "CurrenC CRNC-USDC",
    symbol: "vCRNCUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xD83c52318beB06Adf1853A41694eDFd90891bCE3",
    version: "v2",
    name: "Smooth EURC",
    symbol: "sbEURC",
    asset: {
      address: "0x1aBaEA1f7C830bD89Acc67eC4af516284b1bC33c",
      symbol: "EURC",
    },
  },
  {
    id: "0x704cFb08969048a8DFf298B214F959791d8Da509",
    version: "v2",
    name: "Trezor Steakhouse ETH Prime",
    symbol: "trSHETHp",
    asset: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0x9f3BEbF1159323f78E5c97Cc30f10907B71fCf8C",
    version: "v2",
    name: "Feather USDC",
    symbol: "FeatherUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xECBAcAC6f4D13157249Bc157b05d0d43cd432E83",
    version: "v2",
    name: "cross-collat-usdc",
    symbol: "xcUSDC",
    asset: {
      address: "0xD4fa2D31b7968E448877f69A96DE69f5de8cD23E",
      symbol: "waEthUSDC",
    },
  },
  {
    id: "0x65E3088378b16372e273f9FBaB1a5b323368D6e1",
    version: "v2",
    name: "Helix USDC Vault",
    symbol: "HLXUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xDA64D2440835494EA9a29709A2893F578CC49cc6",
    version: "v2",
    name: "Billion USDC",
    symbol: "billionUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xAbe418cc8c06D265E4EB009C02eA4B265eCA7240",
    version: "v2",
    name: "Saturn USDC",
    symbol: "satUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x07Dd3Cd790a32dC33e98a124881CCC10815b7210",
    version: "v2",
    name: "USDC long-term strategy ",
    symbol: "FR USDC ",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x8aC91877b93330f52b2979a31a4879506021475c",
    version: "v2",
    name: "Huma USDC Main",
    symbol: "humaUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xe3Ba8f17fe581DD473E6699CFaD04502998a57c7",
    version: "v2",
    name: "Mainstreet USDC",
    symbol: "msUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xE9BE5f0e92E941A025d3dd32038250577756a73f",
    version: "v2",
    name: "Keyrock Prime USDT",
    symbol: "kUSDT",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0x41BA71cf6b366C7489AA31D2013e9A26F4c3E2d7",
    version: "v2",
    name: "Keyrock RLUSD",
    symbol: "kRLUSD",
    asset: {
      address: "0x8292Bb45bf1Ee4d140127049757C2E0fF06317eD",
      symbol: "RLUSD",
    },
  },
  {
    id: "0x6B833881A9f083aD2CCACF8c10ABC0dc151cBF32",
    version: "v2",
    name: "SigmaLabs Prime ETH",
    symbol: "sigmaETH",
    asset: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0x43A1A94a8f1C635a4CEDA041A19e833BeE1f3c7E",
    version: "v2",
    name: "Gauntlet USDC Prime",
    symbol: "gtusdcp",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x5B453493D2328E7F747eb2e66446eFe707728be7",
    version: "v2",
    name: "USDC Prime Vault",
    symbol: "usdcpv",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xb8274eFADB953FE9ae052D481a3FC5B6A3ceD703",
    version: "v2",
    name: "USDT Prime Vault",
    symbol: "usdtpv",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0x98D2b241DA14c5dd848812708Eb8A1F3c5512f9d",
    version: "v2",
    name: "WETH Prime Vault",
    symbol: "wethpv",
    asset: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0xCDEc1e92A40aF50dfcAfb9CB07094936C46923FB",
    version: "v2",
    name: "GGDC USDC Vault",
    symbol: "GGDC",
    asset: {
      address: "0x8C35CaA5FD5bDC64b6B11344aD57594A3676256a",
      symbol: "PYUSD",
    },
  },
  {
    id: "0x91393F69A308844a1B4830dE1a57FB489c9D88cE",
    version: "v2",
    name: "Unified Labs Regulated USDC",
    symbol: "ulrUSDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xdcb9a6d103dAe1aB571f746Bb83DED53e665880A",
    version: "v2",
    name: "ByzPrime EUR",
    symbol: "byzEUReri",
    asset: {
      address: "0x1aBaEA1f7C830bD89Acc67eC4af516284b1bC33c",
      symbol: "EURC",
    },
  },
  {
    id: "0x184ad7447D04aa8ce6f75F781Bd00E37421B6eAF",
    version: "v2",
    name: "ByzPrime EUR (insured)",
    symbol: "byzEURieri",
    asset: {
      address: "0x1aBaEA1f7C830bD89Acc67eC4af516284b1bC33c",
      symbol: "EURC",
    },
  },
  {
    id: "0x38895aA5973650feA8b2605F0755bC24a2471d45",
    version: "v2",
    name: "ByzPrime EUR",
    symbol: "byzEURing",
    asset: {
      address: "0x1aBaEA1f7C830bD89Acc67eC4af516284b1bC33c",
      symbol: "EURC",
    },
  },
  {
    id: "0x63Ba70671CB6C93f8f08917088667fd0a26e9407",
    version: "v2",
    name: "ByzPrime EUR (insured)",
    symbol: "byzEURiing",
    asset: {
      address: "0x1aBaEA1f7C830bD89Acc67eC4af516284b1bC33c",
      symbol: "EURC",
    },
  },
  {
    id: "0xe9DC232714f24F0d1b9841E0F2dc61fD064c5B7A",
    version: "v2",
    name: "Billion USDT",
    symbol: "billionUSDT",
    asset: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0xBE8B2bDeA56bc4689650e3af9b93d5D7ce1792A7",
    version: "v2",
    name: "MRNeth",
    symbol: "MRNeth",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x9B2D94ae1e7Fd720913f501A7c4a42fE7c66ad15",
    version: "v2",
    name: "ByzPrime EUR",
    symbol: "byzEURlef",
    asset: {
      address: "0x1aBaEA1f7C830bD89Acc67eC4af516284b1bC33c",
      symbol: "EURC",
    },
  },
  {
    id: "0x5aD0c35a34315f492b6D123De9b93600b82cd574",
    version: "v2",
    name: "ByzPrime EUR (insured)",
    symbol: "byzEURilef",
    asset: {
      address: "0x1aBaEA1f7C830bD89Acc67eC4af516284b1bC33c",
      symbol: "EURC",
    },
  },
  {
    id: "0x3acE737610Da61D004C748275EafD2ECc99802be",
    version: "v2",
    name: "ByzPrime EUR",
    symbol: "byzEURsam",
    asset: {
      address: "0x1aBaEA1f7C830bD89Acc67eC4af516284b1bC33c",
      symbol: "EURC",
    },
  },
  {
    id: "0x6D6860afA39c595EbA06AC641938eE75a3a6C5CB",
    version: "v2",
    name: "ByzPrime EUR (insured)",
    symbol: "byzEURisam",
    asset: {
      address: "0x1aBaEA1f7C830bD89Acc67eC4af516284b1bC33c",
      symbol: "EURC",
    },
  },
  {
    id: "0x6Ac6d74CCA9286d6d8E2e778306026b659482F73",
    version: "v2",
    name: "Test Vault V1",
    symbol: "TVV",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xfB07640C1F623033F805A73FCc84f7eE255a120f",
    version: "v2",
    name: "APYX-USDC",
    symbol: "APYX-USDC",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x5E19F53e2f87CdC440815Cb4a681B8c456896555",
    version: "v2",
    name: "Morpho PoC Dry Run",
    symbol: "MPOCDR",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x67ab2CE741ef205f7a2b573df4f53F4f0e402b4E",
    version: "v2",
    name: "Brookwell Mainnet stcUSD",
    symbol: "brookwell-mainnet-stcusd",
    asset: {
      address: "0x88887bE419578051FF9F4eb6C858A951921D8888",
      symbol: "stcUSD",
    },
  },
  {
    id: "0xaD6fB02E49C5b2546517cE2867e816cF51F6de24",
    version: "v2",
    name: "M11C Vault",
    symbol: "M11C",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x5eF8c2FA6C84AB70e5f2E11B21194A6B5BEfd60E",
    version: "v2",
    name: "JPYR Earn Vault",
    symbol: "vJPYR",
    asset: {
      address: "0xAf5D2cf39F2d4E2F5900D6cf37ab3596866347e4",
      symbol: "JPYR",
    },
  },
  {
    id: "0xF70b879C849e54c99C00dfCd5dbe282f27C08C20",
    version: "v2",
    name: "ZZZ",
    symbol: "ZZZ",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xEbE5792E705db4771b43384B9FA01A30112B6BFa",
    version: "v2",
    name: "Morpho PoC V1",
    symbol: "MPOCv1",
    asset: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xA1347A03343781649D82EB6614ffe7953545Da18",
    version: "v2",
    name: "EURC Strategy",
    symbol: "strgyEURC",
    asset: {
      address: "0x1aBaEA1f7C830bD89Acc67eC4af516284b1bC33c",
      symbol: "EURC",
    },
  },
] as const
